<template>
    <div class="container" data-view>
        <!-- <div id="scene1" class="scene">
            <img data-depth="0.1" src="../assets/img_pertussis/ellipse_orange.png" class="small_orange_ellipse" alt="" id="small_orange_ellipse">
        </div>
        <div id="scene2" class="scene">
            <img data-depth="0.1" src="../assets/img_pertussis/elips_blue.png" class="big_blue_ellipse" alt="" id="big_blue_ellipse">
        </div>
        <div id="scene3" class="scene">
            <img data-depth="0.1" src="../assets/img_pertussis/ellipse_half_blue.png" class="big_half_blue_ellipse" alt="" id="big_half_blue_ellipse">
        </div>
        <div id="scene4" class="scene">
            <img data-depth="0.1" src="../assets/img_pertussis/ellipse_blue_small.png" class="small_blue_ellipse" alt="" id="small_blue_ellipse">
        </div>
        <div id="scene5" class="scene">
            <img data-depth="0.1" src="../assets/img_pertussis/ellips_big_orange.png" class="big_orange_ellipse" alt="" id="big_orange_ellipse">
        </div>
        <div id="scene6" class="scene">
            <img data-depth="0.1" src="../assets/img_pertussis/ellipse_half_blue_small.png" class="small_half_blue_ellipse" alt="" id="small_half_blue_ellipse">
        </div> -->
        <img src="../assets/img_pertussis/ellipse_orange.png" class="small_orange_ellipse" alt="" id="small_orange_ellipse">
        <img src="../assets/img_pertussis/elips_blue.png" class="big_blue_ellipse" alt="" id="big_blue_ellipse">
        <img src="../assets/img_pertussis/ellipse_half_blue.png" class="big_half_blue_ellipse" alt="" id="big_half_blue_ellipse">
        <img src="../assets/img_pertussis/ellipse_blue_small.png" class="small_blue_ellipse" alt="" id="small_blue_ellipse">
        <img src="../assets/img_pertussis/ellips_big_orange.png" class="big_orange_ellipse" alt="" id="big_orange_ellipse">
        <img src="../assets/img_pertussis/ellipse_half_blue_small.png" class="small_half_blue_ellipse" alt="" id="small_half_blue_ellipse">

        <!--<div class="header">
            <img src="../assets/img_pertussis/logo.png" alt="" class="logo1">
        </div>-->
        <Header bgColor="#01BBF5" mobBg="linear-gradient(180deg, #02BBF5 8.27%, #A3E9FF 101.47%)">
            <template v-slot:header-bottom-block><BottomBlock></BottomBlock></template>
        </Header>
        <div v-bind:class="[anchorPressed ? 'anchorIs' : 'hidden_anchor']">
            <div class="blue_anchor" >
                    <img data-depth="0.2" src="../assets/img_pertussis/eli1.png" alt="" class="eli1" id="eli1">
                    <img data-depth="0.2" src="../assets/img_pertussis/eli2.png" alt="" class="eli2" id="eli2">
                    <img data-depth="0.2" src="../assets/img_pertussis/eli3.png" alt="" class="eli3" id="eli3">
                    <img data-depth="0.2" src="../assets/img_pertussis/eli4.png" alt="" class="eli4" id="eli4">
                <!--<div class="men_close">
                    <span onclick="gtag('event', 'meningit', {'event_category': 'main_menu', 'event_label': 'Менінгіт'})">
                        <router-link class="btn menu link_meningit rr12"  to="/"><img src="../assets/img_pertussis/link_meningit.png" alt="" class="link_meningit_logo">Менінгіт</router-link>
                    </span>
                    <button class="btn close_but" v-on:click="closeMenu()">&times;</button>
                </div>

                <div class="rr2">
                    <span onclick="gtag('event', 'kashluk', {'event_category': 'main_menu', 'event_label': 'Кашлюк'})">
                        <button class="btn btn_1"  v-on:click="goToMob('section1')">Кашлюк</button>
                    </span>
                    <span onclick="gtag('event', 'difteria', {'event_category': 'main_menu', 'event_label': 'Діфтерія'})">
                    <button class="btn btn_1"  v-on:click="goToMob('section2')">Дифтерія</button>
                    </span>
                    <span onclick="gtag('event', 'pravec', {'event_category': 'main_menu', 'event_label': 'Правець'})">
                        <button class="btn btn_1"  v-on:click="goToMob('section3')">Правець</button>  
                    </span>

                </div>-->
            </div>
        </div>
        <div class="big_section1 ">
            <div class="blue_header anchorTag anchor" id="stage1">
                <div class="desktop">
                    <div class="left_block">
                        <!--<div class="top">
                            <span onclick="gtag('event', 'meningit', {'event_category': 'main_menu', 'event_label': 'Менінгіт'})">
                                <router-link class="link_meningit" to="/"><img src="../assets/img_pertussis/link_meningit.png" class="link_meningit_logo">Менінгіт</router-link>
                            </span>
                            <span onclick="gtag('event', 'kashluk', {'event_category': 'main_menu', 'event_label': 'Кашлюк'})">
                                <router-link class="button1 no_border" to="/pertussis#section1">Кашлюк</router-link>
                            </span>
                            <span onclick="gtag('event', 'difteria', {'event_category': 'main_menu', 'event_label': 'Діфтерія'})">
                                <router-link class="button1" to="/pertussis#section2">Дифтерія</router-link>
                            </span>
                            <span onclick="gtag('event', 'pravec', {'event_category': 'main_menu', 'event_label': 'Правець'})">
                                <router-link class="button1" to="/pertussis#section3">Правець</router-link>
                            </span>
                        </div>-->
                        <div class="bottom">
                            <div id="anim1" class="anim1 font_text text-white text-firstheader text-bold">Що потрібно знати про дитячі інфекції у школі</div>    
                            <div class="subtext" id="anim2">
                                <span class="font_text text-white text-bold text_32" >Ваша дитина пішла у школу: </span><br>
                                <span class="font_text text-white text_32">як допомогти їй швидко адаптуватися до нової реальності?</span> 
                            </div>
                        </div>

                    </div>
                    <div class="right_block" id="anim3">
                        <img src="../assets/img_pertussis/girl_and_mom.png" class="girl_and_mom" alt="" >
                    </div>
                </div>
                <div class="mobile">
                    <!--<div class="top_block">
                        <div>
                            <router-link class="link_meningit" to="/"><img src="../assets/img_pertussis/link_meningit.png" class="link_meningit_logo">Менінгіт</router-link>
                        </div>
                        <div  v-on:click="openMenu()">
                            <img src="../assets/img_pertussis/menu.png" alt="">
                        </div>
                    </div>-->
                    <div class="bottom_block">
                        <span class="font_text text-white text-firstheader text-bold">Що потрібно знати про дитячі інфекції у школі</span> 
                        <img src="../assets/img_pertussis/mom_and_girl_small.png" class="girl_and_mom" alt="" >   
                        <div class="subtext">
                            <span class="font_text text-white text-bold text_32">Ваша дитина пішла у школу: </span><br>
                            <span class="font_text text-white text_32">як допомогти їй швидко адаптуватися до нової реальності?</span> 
                        </div>
                    </div>
                </div>

            </div>
            <div class="main_info anchorTag" id="stage2">
                <div class="head">
                    <span class="font_text text-subheader text-blue text-bold" id="saf1">Турбота про здоров'я дитини в перші шкільні роки – це важливий і відповідальний етап для батьків і дітей.</span> 
                </div>
                <div class="text">
                    <div class="first_sec">
                        <span class="font_text text_standart text-colored">
                            Спостереження за першокласниками показали, що адаптація до школи триває від 2-3 тижнів до півроку і залежить від багатьох причин. <br> <br>
                            У цей період важливо, щоб організм дитини був підготовлений до нових умов, адже в  
                        </span>
                        <span style="color: #F4A032;" class="font_text text_standart text-bold">
                            момент контакту з новими людьми ризик зараження захворюваннями, що передаються повітряно-крапельним шляхом, найвищий.<sup>1</sup>
                        </span>
                    </div>
                    <div class="second_sec">
                        <span style="color: #F4A032;" class="font_text text_standart text-bold">
                            Вакцинація покликана допомогти запобігти цьому. 
                        </span> <br><br>
                        <span class="font_text text_standart text-colored">
                            Тому своєчасна допомога імунітету насамперед спрямована на захист від інфекцій, з якими ми стикаємося в повсякденному житті. 
                        </span>
                    </div>
                </div>

            </div>
            <div class="orange_box1 anchorTag" id="stage3">
                <div class="img">
                    <img src="../assets/img_pertussis/icon_doctor.png" class="icon_doctor" alt="">
                </div>
                <div class="text">
                    <span class="font_text text_32 text-white text-bold">Важливо пам'ятати, що визначити правильну схему вакцинації та у разі необхідності дати відповідні рекомендації може тільки лікар. </span>
                </div>
            </div>
            <div class="after_orange_box anchorTag" id="stage4">
                <div class="left_section">
                    <div class="main">
                        <div class="img">
                            <img src="../assets/img_pertussis/icon_medicine.png" class="medicine_icon" alt="">
                        </div>
                        <div class="text">
                            <span class="font_text text-subheader text-blue text-bold">Від яких інфекцій дитина повинна бути щеплена </span>
                            <br>
                            <span class="font_text text-subheader text-orange text-bold">
                                до 6-7 років?
                            </span>
                        </div>
                    </div>
                    <div class="not_main">
                        <span class="font_text text_standart text-colored">
                            Наразі в Україні обов'язковою є вакцинація дітей 
                        </span>
                        <span class="font_text text_standart text-bold">
                            від 10 небезпечних хвороб<sup>2,3</sup>
                        </span>
                    </div>

                </div>
                <div class="right_section">
                    <img src="../assets/img_pertussis/tab_1.png" class="tab_1" alt="">
                </div>

            </div>
            <div class="before_deseases anchorTag" id="stage5">
                <div class="head">
                    <span class="font_text text-subheader text-blue text-bold" id="saf2">Перед вступом до школи та у шкільні роки дітям рекомендується проводити ревакцинацію від таких інфекцій:</span>
                </div>
                <div class="counter">
                    <div class="first_three">
                        <div class="counting">
                            <div class="number text-white font_text no_border">
                                1
                            </div>
                            <div class="name">
                                <span class="font_text text_32 text-bold">Кір</span>
                            </div>
                        </div>
                        <div class="counting">
                            <div class="number text-white">
                                2
                            </div>
                            <div class="name">
                                <span class="font_text text_32 text-bold">Правець</span>
                            </div>
                        </div>
                        <div class="counting">
                            <div class="number text-white">
                                3
                            </div>
                            <div class="name">
                                <span class="font_text text_32 text-bold">Епідемічний паротит</span>

                            </div>
                        </div>
                    </div>
                    <div class="second_three">
                        <div class="counting">
                            <div class="number text-white">
                                4
                            </div>
                            <div class="name">
                                <span class="font_text text_32 text-bold">Дифтерія</span>
                            </div>
                        </div>
                        <div class="counting">
                            <div class="number text-white">
                                5
                            </div>
                            <div class="name">
                                <span class="font_text text_32 text-bold">Краснуха</span>
                            </div>
                        </div>
                        <div class="counting">
                            <div class="number text-white">
                                6
                            </div>
                            <div class="name">
                                <span class="font_text text_32 text-bold">Поліомієліт</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="to-top">
            <svg @click="toTop()" width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect opacity="0.15" x="0.5" y="0.5" width="47" height="47" rx="11.5" fill="#537FCB" stroke="#537FCB"/>
                <path d="M10.9393 27.5546C10.3536 28.1404 10.3536 29.0901 10.9393 29.6759C11.5251 30.2617 12.4749 30.2617 13.0607 29.6759L10.9393 27.5546ZM24 16.6152L25.0607 15.5546C24.4749 14.9688 23.5251 14.9688 22.9393 15.5546L24 16.6152ZM34.9393 29.6759C35.5251 30.2617 36.4749 30.2617 37.0607 29.6759C37.6464 29.0901 37.6464 28.1404 37.0607 27.5546L34.9393 29.6759ZM13.0607 29.6759L25.0607 17.6759L22.9393 15.5546L10.9393 27.5546L13.0607 29.6759ZM22.9393 17.6759L34.9393 29.6759L37.0607 27.5546L25.0607 15.5546L22.9393 17.6759Z" fill="#537FCB"/>
            </svg>
        </div>

        <div class="big_section2">
            <img src="../assets/img_pertussis/el1.png" class="el1" alt="">
            <img src="../assets/img_pertussis/el2.png" class="el2" alt="">
            <img src="../assets/img_pertussis/el3.png" class="el3" alt="">
            <img src="../assets/img_pertussis/el4.png" class="el4" alt="">
            <img src="../assets/img_pertussis/el5.png" class="el5" alt="">
            <img src="../assets/img_pertussis/el6.png" class="el6" alt="">
            <img src="../assets/img_pertussis/el7.png" class="el7" alt="">
            <img src="../assets/img_pertussis/el8.png" class="el8" alt="">
            <img src="../assets/img_pertussis/el9.png" class="el9" alt="">
            <img src="../assets/img_pertussis/el10.png" class="el10" alt="">
            <div class="anchor start_text anchorTag" id="stage6">
                <div class="left">
                    <span class="font_text text-subheader text-white text-bold">Чим небезпечні кашлюк, дифтерія та правець? </span>
                </div>
                <div class="right">
                    <span class="font_text text_standart text-white">
                        Особливість кашлюку та дифтерії – повітряно- крапельний шлях передачі, тобто в процесі контактування з іншими людьми.<sup>4,5 </sup> 
                        <br> <br>        
                        Правець передається через потрапляння збудника в пошкоджені тканини організму.<sup>6</sup>
                    </span>
                    
                </div>
            </div>
            <div class="pert acnhorTag" id="section1">
                <div class="sect_1">
                    <div class="desktop">
                        <div class="left">
                            <img
                                src="../assets/img_pertussis/kashluk.png"
                                class="img_kashluk"
                                alt=""
                            >
                        </div>
                        <div class="right">
                            <span class="font_text text-orange text-bold text-header">Кашлюк</span> <br>
                            <span class="font_text text-bold text_standart">
                                Гостра повітряно-крапельна бактеріальна інфекція,</span> 
                            <span class="font_text text_standart"> що проявляється тривалими і болісними нападами спазматичного кашлю і інтоксикацією.<sup>4</sup>  </span>
                        </div>
                    </div>
                    <div class="mobile">
                        <span class="font_text text-orange text-bold text-header">Кашлюк</span> <br>
                        <img src="../assets/img_pertussis/kashluk.png" class="img_kashluk" alt="">
                        <span class="font_text text-bold text_standart">
                            Гостра повітряно-крапельна бактеріальна інфекція,</span> 
                        <span class="font_text text_standart"> що проявляється тривалими і болісними нападами спазматичного кашлю і інтоксикацією.<sup>4</sup></span>
                    </div>
                    <div class="divider">

                    </div>
                </div>
                <div class="sect_2 anchorTag" id="ka2">
                    <div class="section1_box_counter">
                        <div class="section1_counter_item" id="ka2item1">
                            <span class="orange_dot">            
                            </span>
                            <span class="font_text text_standart">
                                <span style="font-weight:700;">Заразитися</span>  кашлюком дитина може тільки від хворої людини.<sup>7</sup> 
                            </span>
                        </div>
                        <div class="section1_counter_item" id="ka2item2">
                            <span class="orange_dot">
                            </span>
                            <span class="font_text text_standart">
                                Якщо серед 100 нещеплених буде 1 людина, заражена кашлюком, <span class="text-bold"> близько 90 осіб захворіють!<sup>7</sup> </span> 
                            </span>
                        </div> 
                        <div class="section1_counter_item" id="ka2item3">
                            <div class="orange_dot">
                            </div>
                            <span class="font_text text_standart">
                                Інфекція передається повітряно-крапельним шляхом <span class="text-bold">під час чхання, кашлю, сміху<sup>4</sup></span> 
                            </span>
                        </div>
                        <div class="section1_counter_item" id="ka2item4">
                            <span class="orange_dot">
                            </span>
                            <span class="font_text text_standart">
                                Хворий на кашлюк є джерелом інфекції для оточуючих <span class="text-bold">з першого дня і до 30 діб хвороби<sup>8</sup> </span>
                            </span>
                        </div>
                    </div>
                    <!-- <div class="flexing">
                        <div class="counting">
                            <div class="orange_dot">
                            </div>
                            <div class="text">
                                <span style="font-weight:500;">Заразитися</span>  кашлюком дитина може тільки <br> від хворої людини.7
                            </div>
                        </div>
                        <div class="counting">
                            <div class="orange_dot">
                            </div>
                            <div class="text">
                                <span>
                                    Інфекція передається повітряно-крапельним <br> шляхом <span style="font-weight:500;">під час чхання, кашлю, сміху4</span> 
                                </span>

                            </div>
                        </div>
                    </div>
                    <div class="flexing">
                        <div class="counting">
                            <div class="orange_dot">
                            </div>
                            <div class="text">
                                <span >
                                    Якщо серед 100 нещеплених буде 1 людина, <br> заражена кашлюком, <span style="font-weight:500;"> близько 90 осіб <br> захворіють!7</span> 
                                </span>
                            </div>
                        </div>
                        <div class="counting">
                            <div class="orange_dot">
                            </div>
                            <div class="text">
                                <span>
                                    Хворий на кашлюк є джерелом інфекції для <br> оточуючих <span style="font-weight:500;">з першого дня і до 30 діб <br> хвороби8 </span>
                                </span>
                            </div>
                        </div>
                    </div> -->

                </div>
                <div class="divider">
                </div>
                <div class="sect_3 anchorTag" id="ka3">
                    <div class="fst">
                        <div class="main_info_holder1">
                            <img src="../assets/img_pertussis/icon_increase.png" class="img11" alt="">
                        </div>
                        <div class="main_info_header1">
                            <span class="font_text text-orange text_32 text-bold ">В Україні протягом останніх років значно збільшилась захворюваність на кашлюк, особливо серед дітей дошкільного та шкільного віку.<sup>9</sup></span>
                        </div>
                    </div>
                    <div class="main_info_text1">
                        <span class="font_text text_standart">
                        Причиною цього є зниження поствакцинального імунітету, що сприяє відновленню сприйнятливості до кашлюку, починаючи з 5-7 років. 
                        </span> <br> <br>
                        <span class="font_text text_standart">
                            Найбільше схильні до захворювання діти, проте у школі джерелами інфекції часто бувають дорослі: вчителі або обслуговуючий персонал. 
                        </span>
                    </div>
                    <div class="main_info_1_labels">
                        <img src="../assets/img_pertussis/icon_warning.png" class="img_dan" alt="">
                        <div class="main_info1_danger_holder">
                            <span class="font_text text-orange text-bold text-subheader3">
                                Кашель може тривати більше 3 місяців<sup>4</sup>
                            </span>
                            
                        </div>
                        <div class="main_info1_right" style="margin-left: 0px;">
                            <span class="font_text text-orange text-bold text-subheader3">
                                Дитина може перебувати на домашньому або лікарняному режимі 21 день
                            </span>
                        </div>
                    </div>
                </div>
                <div class="divider">
                </div>
                <div class="sec_4">
                    <div class="symbtoms1_header">
                        <span class="text-orange font_text text-subheader text-bold">
                            Симптоми 
                        </span>
                    </div>
                    <div class="symbtoms1_text">
                        <span class="font_text text-bold text_standart">
                            Перший період захворювання триває 2 тижні.<sup>4</sup>
                        </span>
                    </div>
                    <div class="symbtoms1_item_holder anchorTag" id="ka4">
                        <div class="fst">
                            <div class="symbtoms1_item" id="symb1">
                                <div class="symb1_item_img">
                                    <img src="../assets/img_pertussis/icon_temp.png" width="140" class="im_symb12" alt="">
                                </div>
                                <div class="symb1_item_desc font_text text_standart4">
                                    Підвищується <br> <span class="text-bold">температура</span> 
                                </div>
                            </div>
                            <div class="symbtoms1_item" id="symb2">
                                <div class="symb1_item_img">
                                    <img src="../assets/img_pertussis/icon_bed.png" width="140" class="im_symb12" alt="">

                                </div>
                                <div class="symb1_item_desc font_text text_standart4">
                                    Спостерігається <br> загальна <br>
                                       <span class="text-bold">слабкість</span> 
                                </div>
                            </div>
                            <div class="symbtoms1_item" id="symb3">
                                <div class="symb1_item_img">
                                    <img src="../assets/img_pertussis/icon_sneeze.png" width="140" class="im_symb12" alt="">
                                </div>
                                <div class="symb1_item_desc font_text text_standart4">
                                   <span class="text-bold">Схоже на класичну <br>
                                    ГРВІ</span>  з рясними <br>   виділеннями з носа
                                </div>
                            </div>
                        </div>
                        <div class="scd">
                            <div class="symbtoms1_item" id="symb4">
                                <div class="symb1_item_img" style="">
                                    <img src="../assets/img_pertussis/icon_cough.png" width="140" class="im_symb12" alt="">
                                </div>
                                <div class="symb1_item_desc font_text text_standart4">
                                   <span class="text-bold">Потім кашель посилюється <br> і набуває спазматичного <br> характеру.</span>  Болісні напади <br> кашлю нерідко провокують <br> блювання.<sup>8</sup> 
                                </div>
                            </div>
                            <div class="symbtoms1_item" id="symb5">
                                <div class="symb1_item_img" style="">
                                    <img src="../assets/img_pertussis/icon_lungs.png" width="140" class="im_symb12" alt="">

                                </div>
                                <div class="symb1_item_desc font_text text_standart4">
                                    Найбільшу небезпеку <br> становлять ускладнення <br> кашлюку, серед яких <br> <span class="text-bold"> пневмонія, судоми, <br> порушення функції легень.</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="divider">

                </div>
                <div class="sec_5">
                    <div class="head2">
                        <div class="head2_img">
                                <img src="../assets/img_pertussis/oneyear.png" class="typic_img_with_child" alt="">

                        </div>
                        <div class="head2_text">
                            <div class="head2_header text_32 font_text text-orange text-bold">
                                Діти 1-го року життя 
                            </div>
                            <div class="head2_text_after font_text text_standart">
                                
                                залишаються найвразливішою групою, у якій спостерігається найвищий рівень захворюваності і частота ускладнень.<sup>7</sup>
                            </div>
                        </div>
                    </div>
                    <div class="main-text2 font_text text_standart">
                        За даними експертів, <span class="text-bold"> багато дітей отримують повний курс первинної вакцинації від кашлюку несвоєчасно </span>– лише до досягнення віку 12 місяців. До отримання вакцини організм новонародженого не здатний ефективно боротися з інфекцією, і найбільша кількість летальних випадків спостерігається серед дітей до 1 року.<sup>11</sup> 
                        <br><br>
                        <span class="text-bold"> У ~80% випадків</span> основним джерелом зараження кашлюком для малюків до 1 року є діти старшого віку, підлітки та дорослі (старші брати і сестри, батьки, близькі родичі).<sup>10</sup> 
                    </div>
                    <div class="blue_rect1 font_text text-white text-standart text-bold">
                        Додаткова ревакцинація проти кашлюку дає змогу захистити дитину від небезпечної інфекції та перешкоджає передаванню кашлюку найбільш вразливій групі – дітям до 1 року, зменшуючи ризик їх зараження! 
                        <br><br>
                        <span class="big_text_main1 text_standart2 text-bold"> Запобігти хворобі можна за допомогою щеплення<sup>9,11</sup></span>

                    </div>
                    <div class="llDiag">
                        <div class="diagnost text_32 font_text text-subheader text-orange text-bold">
                            Діагностика кашлюку 
                        </div>
                        <div class="diagnost_text font_text text_standart">
                            У разі появи кашлю слід звертатися до лікаря для виключення ГРВІ, бронхіту та інших захворювань. Запідозривши кашлюк, лікар візьме аналіз крові на антитіла до збудника кашлюку і/або мазок з носоглотки на кашлюк. Може знадобитися рентгенографія легень. 
                            <br><br>
                            <span class="text-bold">Пам'ятайте! На кашлюк можуть захворіти люди будь-якого віку і стати джерелом інфекції для дитини! 
                            </span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="dift anchorTag anchor" id="section2">
                <div class="upper2" >
                    <div class="img_holder_sec2">
                        <img src="../assets/img_pertussis/sec2.png" alt="" class="img_sec2">
                    </div>
                    <div class="sec2_upper_rig">
                        <div class="head_upper2 text-firstheader text-orange font_text text-bold">
                            Дифтерія 
                        </div>
                        <div class="head_upper2_text font_text text_standart">
                            <span class="text-bold">Це тяжка і небезпечна для життя бактеріальна інфекція,</span> що спричиняється дифтерійною паличкою. Хвороба протікає у вигляді гострого запалення ротоглотки, але нерідко зачіпає гортань, бронхи, шкіру та інші органи. 
                        </div>
                    </div>
                </div>
                <div class="upper21" >
                    <div class="sec2_upper_rig">
                        <div class="head_upper2 text-subheader text-orange font_text text-bold">
                            Дифтерія 
                        </div>
                        <div class="img_holder_sec2">
                            <img src="../assets/img_pertussis/sec2.png" alt="" class="img_sec2">
                        </div>
                        <div class="head_upper2_text font_text text_standart">
                            <span class="text-bold">Це тяжка і небезпечна для життя бактеріальна інфекція,</span> що спричиняється дифтерійною паличкою. Хвороба протікає у вигляді гострого запалення ротоглотки, але нерідко зачіпає гортань, бронхи, шкіру та інші органи. 
                        </div>
                    </div>
                </div>
                <div class="divider" >

                </div>
                <div class="osn_shl_per anchorTag" id="di1">
                    <div class="ons_shl_title font_text text-orange text-subheader text-bold">
                        Основні шляхи передачі: 
                    </div>
                    <div class="counter">
                        <div class="shl_per" id="dis1">
                            <div class="shl_per_holder">
                                <img src="../assets/img_pertussis/icon_breathe.png" alt="" class="shl_per_img">
                            </div>
                            <div class="shl_per_text font_text text-bold text_standart">
                                Повітряно- <br>  крапельний
                            </div>
                        </div>
                        <div class="shl_per" id="dis2">
                            <div class="shl_per_holder">
                                <img src="../assets/img_pertussis/icon_toy.png" alt="" class="shl_per_img">
                            </div>
                            <div class="shl_per_text font_text text-bold text_standart">
                                Предмети та <br> іграшки 
                            </div>
                        </div>
                        <div class="shl_per" id="dis3">
                            <div class="shl_per_holder">
                                <img src="../assets/img_pertussis/icon_dish.png" alt="" class="shl_per_img">
                            </div>
                            <div class="shl_per_text font_text text-bold text_standart">
                                Посуд 
                            </div>
                        </div>
                    </div>
                </div>
                <div class="divider"></div>
                <div class="osn_shl_per anchorTag" id="di3">
                    <div class="ons_shl_title font_text text-orange text-subheader text-bold">
                        Ускладнення 
                    </div>
                    <div class="counter">
                        <div class="shl_per1" id="dit1">
                            <div class="shl_per_holder">
                                <img src="../assets/img_pertussis/icon_cross.png" alt="" class="shl_per_img">
                            </div>
                            <div class="shl_per_text font_text text-bold text_standart">
                                Летальність <br> до 10% 
                            </div>
                        </div>
                        <div class="shl_per1" id="dit2">
                            <div class="shl_per_holder">
                                <img src="../assets/img_pertussis/icon_change.png" alt="" class="shl_per_img">
                            </div>
                            <div class="shl_per_text1 font_text  text_standart">
                                Початкову <br> стадію можна <br> переплутати <br> <span class="text-bold">з ангіною </span> 
                            </div>
                        </div>
                        <div class="shl_per1" id="dit3">
                            <div class="shl_per_holder">
                                <img src="../assets/img_pertussis/icon_daanger.png" alt="" class="shl_per_img">
                            </div>
                            <div class="shl_per_text1 font_text  text_standart">
                               <span class="text-bold">Небезпечна</span>  <br> ураженням серця, <br> нирок і нервової <br> системи, може <br> спричинити задуху 
                            </div>
                        </div>

                    </div>

                </div>
            </div>
            <div class="pravec anchorTag anchor" id="section3">
                <div class="upper2" >
                    <div class="img_holder_sec2">
                        <img src="../assets/img_pertussis/pravec.png" alt="" class="img_sec2">
                    </div>
                    <div class="sec2_upper_rig">
                        <div class="head_upper2 text-firstheader text-orange font_text text-bold">
                            Правець  
                        </div>
                        <div class="head_upper2_text font_text text_standart">
                            <span class="text-bold">Вкрай небезпечне інфекційне захворювання бактеріальної природи.</span> Збудник, правцева паличка, живе в кишечнику тварин і після потрапляння в ґрунт трансформується у спори.<sup>6</sup> 
                        </div>
                    </div>
                </div>
                <div class="upper21" >
                    <div class="sec2_upper_rig">
                        <div class="head_upper2 text-firstheader text-orange font_text text-bold">
                            Правець  
                        </div>
                        <div class="img_holder_sec2">
                            <img src="../assets/img_pertussis/pravec.png" alt="" class="img_sec2">
                        </div>
                        <div class="head_upper2_text font_text text_standart">
                            <span class="text-bold">Вкрай небезпечне інфекційне захворювання бактеріальної природи.</span> Збудник, правцева паличка, живе в кишечнику тварин і після потрапляння в ґрунт трансформується у спори.<sup>6</sup>
                        </div>
                    </div>
                </div>
                <div class="divider"></div>
                <div class="osn_shl_per anchorTag" id='pa1'>
                    <div class="ons_shl_title font_text text-orange text-subheader text-bold">
                        Основні шляхи передачі: 
                    </div>
                    <div class="counter">
                        <div class="shl_per" id="pra1">
                            <div class="shl_per_holder">
                                <img src="../assets/img_pertussis/icon_hand.png" alt="" class="shl_per_img">
                            </div>
                            <div class="shl_per_text font_text text-bold text_standart">
                                Контактні <br>  шляхи
                            </div>
                        </div>
                        <div class="shl_per" id="pra2">
                            <div class="shl_per_holder">
                                <img src="../assets/img_pertussis/icon_spot.png" alt="" class="shl_per_img">
                            </div>
                            <div class="shl_per_text font_text text-bold text_standart">
                                Забруднення <br> рани 
                            </div>
                        </div>
                        <div class="shl_per" id="pra3">
                            <div class="shl_per_holder">
                                <img src="../assets/img_pertussis/icon_patch.png" alt="" class="shl_per_img">
                            </div>
                            <div class="shl_per_text font_text text-bold text_standart">
                                Пластир 
                            </div>
                        </div>
                    </div>
                </div>
                <div class="divider"></div>
                <div class="osn_shl_per anchorTag" id="pa2" >
                    <div class="ons_shl_title font_text text-orange text-subheader text-bold">
                        Ускладнення 
                    </div>
                    <div class="counter1">
                        <div class="shl_per" id="pta1">
                            <div class="shl_per_holder">
                                <img src="../assets/img_pertussis/icon_cross.png" alt="" class="shl_per_img">
                            </div>
                            <div class="shl_per_text font_text text-bold text_standart">
                                Летальність <br> від 10% до <br> 70% 
                            </div>
                        </div>
                        <div class="shl_per" id="pta2">
                            <div class="shl_per_holder">
                                <img src="../assets/img_pertussis/icon_change.png" alt="" class="shl_per_img">
                            </div>
                            <div class="shl_per_text font_text  text_standart">
                               <span class="text-bold"> Тяжкий перебіг</span> з <br> ураженням нервової <br> системи, судомами 
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
        <div class="big_section3">
            <div class="blue_smth">
                <div class="blue_img">
                    <img src="../assets/img_pertussis/icon_calendar.png" alt="">
                </div>
                <div class="text-white font_text text-bold text_standart2">
                    Слід регулярно (кожні 10 років) проводити ревакцинацію від дифтерії та правця згідно з національним календарем щеплень.<sup>2</sup> 
                </div>
            </div>
            <div class="flexing">
                <div class="left_smth">
                    <div class="head text-blue text-bold font_text text_32">
                        Навіщо потрібна ревакцинація перед вступом до школи?<sup>12</sup> 
                    </div> <br>
                    <div class="just_txt font_text text_standart">
                        Похід у перший клас – велике навантаження для дитини, стрес і період адаптації ослаблюють її імунітет. <br> <br>

                        Зменшення ризику інфікування є важливою умовою для здорового розвитку ваших дітей. Завжди краще запобігти можливості захворіти, ніж чекати і сподіватися, що проблема обійде вас стороною. 
                    </div>
                </div>
                <div class="right_smth">
                    <img src="../assets/img_pertussis/tab_2.png" class="tab2" alt="">
                </div>
            </div>

            <div class="some_warning text_standart3 font_text text-bold">
                Представлена ​​інформація не замінює консультацію лікаря, будь ласка, зверніться до Вашого педіатра
            </div>
        </div>
        <div class="links-wrapper">
            <div class="content">
                <div class="show-hide-btn" @click="showLinks = !showLinks" v-bind:class="[{ active: showLinks }]">
                Джерела
                <svg width="15" height="9" viewBox="0 0 15 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M14.5 8.5L7.5 1.5L0.5 8.5" stroke="#3F4C56"/>
                </svg>

                </div>
                <div v-bind:class="[{ active: showLinks }]" class="hide-content">
                <div class="list"><span>1. </span>
        Liang JL, et al. Prevention of Pertussis, Tetanus, and Diphtheria with Vaccines in the United States: Recommendations of the Advisory Committee on Immunization Practices (ACIP)MMWR. U.S. Department of Health and Human Services Centers for Disease Control and Prevention. 2018;67:1-44. 
                </div>
                <div class="list"><span>2. </span>
        Календар профілактичних щеплень (moz.gov.ua)
                    <a href="https://moz.gov.ua/article/immunization/kalendar-profilaktichnih-scheplen"
                    target="_blank">https://moz.gov.ua/article/immunization/kalendar-profilaktichnih-scheplen</a>
                    Остання дата
                    доступу 29.03.2021.
                </div>
                <div class="list"><span>3. </span>
        Наказ МОЗ України від 18.05.2018 № 947 "Про внесення змін до Календаря профілактичних щеплень в Україні"

                    <a href="https://zakon.rada.gov.ua/laws/show/z0659-18#Text"
                    target="_blank">https://zakon.rada.gov.ua/laws/show/z0659-18#Text</a>
                    Остання
                    дата доступу 15.06.2021.
                </div>
                <div class="list"><span>4. </span>
        Як вберегти дитину від кашлюка? (moz.gov.ua)

                    <a href="https://moz.gov.ua/article/news/jak-vberegti-ditinu-vid-kashljuka"
                    target="_blank">https://moz.gov.ua/article/news/jak-vberegti-ditinu-vid-kashljuka</a> Остання дата доступу
                    29.03.2021.
                </div>
                <div class="list"><span>5. </span>
        Дифтерія | Центр громадського здоров’я (phc.org.ua)  

                    <a href="https://phc.org.ua/kontrol-zakhvoryuvan/inshi-infekciyni-zakhvoryuvannya/difteriya"
                    target="_blank">https://phc.org.ua/kontrol-zakhvoryuvan/inshi-infekciyni-zakhvoryuvannya/difteriya</a> Остання дата доступу
                    29.03.2021.
                </div>
                <div class="list"><span>6. </span>
        Правець | Центр громадського здоров’я (phc.org.ua) 
                    <a href="https://phc.org.ua/kontrol-zakhvoryuvan/inshi-infekciyni-zakhvoryuvannya/pravec" target="_blank">https://phc.org.ua/kontrol-zakhvoryuvan/inshi-infekciyni-zakhvoryuvannya/pravec</a>
                    Остання дата доступу 29.03.2021 
                </div>
                <div class="list"><span>7. </span>
        World Health Organization. Weekly Epidemiol Rec 2015;90:433-458.
                    <a href="http://www.who.int/wer/2015/wer9035.pdf" target="_blank">http://www.who.int/wer/2015/wer9035.pdf</a>
                    Остання дата доступу 29.03.2021 .
                </div>
                <div class="list"><span>8. </span>
        Кашлюк у дітей. З турботою про дитину, 2016;1(55)
                    <a href="https://extempore.info/component/content/article/9-joornal/562-kashlyuk-u-ditey.html?Itemid=357"
                    target="_blank">https://extempore.info/component/content/article/9-joornal/562-kashlyuk-u-ditey.html?Itemid=357</a>
                    Остання
                    дата доступу 29.03.2021 .
                </div>
                <div class="list"><span>9. </span>
        Кашлюк у дітей | Блоги БДМУ (bsmu.edu.ua)
                    <a href="https://www.bsmu.edu.ua/blog/2773-kashlyuk-u-ditey/" target="_blank">https://www.bsmu.edu.ua/blog/2773-kashlyuk-u-ditey/</a>
                    Остання дата доступу 29.03.2021.
                </div>
                <div class="list"><span>10. </span>
        Skoff TH et al. Sources of Infant Pertussis Infection in the United States. Pediatrics. 2015;136(4):635-41. 
                </div>
                <div class="list"><span>11. </span>
        Про захворювання та вакцини | Центр громадського здоров’я (phc.org.ua)
                        <a
                        href="https://phc.org.ua/kontrol-zakhvoryuvan/imunizaciya/pro-zakhvoryuvannya-ta-vakcini" target="_blank">https://phc.org.ua/kontrol-zakhvoryuvan/imunizaciya/pro-zakhvoryuvannya-ta-vakcini</a>
                    Остання дата доступу 29.03.2021. 
                </div>
                <div class="list"><span>12. </span>
        Невакциновані діти не можуть відвідувати школи та дитячі садки (moz.gov.ua)                 <a
                        href="https://moz.gov.ua/article/news/nevakcinovani-diti-ne-mozhut-vidviduvati-shkoli-ta-ditjachi-sadki" target="_blank">https://moz.gov.ua/article/news/nevakcinovani-diti-ne-mozhut-vidviduvati-shkoli-ta-ditjachi-sadki</a>
                    Остання дата доступу 29.03.2021.
                </div>
            </div>
        </div>

    </div>
    <div class="med-text">
        <!-- <img src="../assets/img_pertussis/samo.png" class="im" alt="">
        <img src="../assets/img_pertussis/samo_small.png" class="im1" alt=""> -->
      <footer
          id="self-medication-block">
        <div class="word">
          <div class="letter s"></div>
          <div
              class="letter a"></div>
          <div
              class="letter m bigger-letter"></div>
          <div
              class="letter o"></div>
          <div
              class="letter l"></div>
          <div
              class="letter i smaller-letter"></div>
          <div
              class="letter k"></div>
          <div
              class="letter u"></div>
          <div class="letter v"></div>
          <div class="letter a"></div>
          <div
              class="letter n"></div>
          <div class="letter n"></div>
          <div class="letter ia"></div>
        </div>
        <div
            class="word">
          <div
              class="letter m bigger-letter"></div>
          <div class="letter o"></div>
          <div
              class="letter ge bigger-letter"></div>
          <div class="letter e"></div>
        </div>
        <div class="word">
          <div
              class="letter b"></div>
          <div class="letter u"></div>
          <div class="letter t"></div>
          <div
              class="letter ii"></div>
        </div>
        <div class="word">
          <div
              class="letter sh bigger-letter"></div>
          <div
              class="letter k"></div>
          <div
              class="letter i smaller-letter"></div>
          <div
              class="letter d"></div>
          <div
              class="letter l"></div>
          <div class="letter ii"></div>
          <div class="letter v"></div>
          <div
              class="letter ii"></div>
          <div
              class="letter m bigger-letter"></div>
        </div>
        <div class="word">
          <div
              class="letter d"></div>
          <div class="letter l"></div>
          <div class="letter ia"></div>
        </div>
        <div
            class="word">
          <div class="letter v"></div>
          <div class="letter a"></div>
          <div
              class="letter sh bigger-letter"></div>
          <div class="letter o"></div>
          <div
              class="letter g"></div>
          <div
              class="letter o"></div>
        </div>
        <div class="word">
          <div class="letter z"></div>
          <div
              class="letter d"></div>
          <div class="letter o"></div>
          <div class="letter r"></div>
          <div
              class="letter o"></div>
          <div class="letter v"></div>
          <div
              class="letter znak smaller-letter"></div>
          <div class="letter ia"></div>
        </div>

        <svg id="self-medication-svg" viewBox="0 0 316 88" fill="none"
             xmlns="http://www.w3.org/2000/svg">
          <path
              d="M5.96402 10.3896C3.40201 10.3896 1.89001 11.5236 1.89001 14.0436V36.5976C1.89001 39.1596 3.40201 40.2516 5.96402 40.2516H6.84601C9.40802 40.2516 10.962 39.1596 10.962 36.5976V33.0696H10.122V35.5476C10.122 38.6556 9.36601 39.4956 6.84601 39.4956H5.96402C3.44402 39.4956 2.73001 38.6556 2.73001 35.5476V15.0936C2.73001 11.9856 3.44402 11.1456 5.96402 11.1456H6.84601C9.36601 11.1456 10.122 11.9856 10.122 15.0936V17.6136H10.962V14.0436C10.962 11.4816 9.40802 10.3896 6.84601 10.3896H5.96402ZM24.1976 39.9996L20.1236 10.5996H18.8216L14.7476 39.9996H15.5036L16.9736 29.3316H21.9716L23.4416 39.9996H24.1976ZM19.4096 11.5236H19.4936L20.1656 16.4796L21.8456 28.5336H17.0996L18.7796 16.4796L19.4096 11.5236ZM41.727 39.9996V10.5996H40.257L35.385 39.5376H35.301L30.429 10.5996H28.959V39.9996H29.799V11.8176H29.883L34.629 39.9996H36.057L40.845 11.8176H40.929V39.9996H41.727ZM51.5274 10.3896C48.9654 10.3896 47.4534 11.5236 47.4534 14.0436V36.5976C47.4534 39.1596 48.9654 40.2516 51.5274 40.2516H52.4094C54.9714 40.2516 56.5254 39.1596 56.5254 36.5976V14.0436C56.5254 11.4816 54.9714 10.3896 52.4094 10.3896H51.5274ZM52.4094 11.1456C54.9294 11.1456 55.6854 11.9856 55.6854 15.0936V35.5476C55.6854 38.6556 54.9294 39.4956 52.4094 39.4956H51.5274C49.0074 39.4956 48.2934 38.6556 48.2934 35.5476V15.0936C48.2934 11.9856 49.0074 11.1456 51.5274 11.1456H52.4094ZM71.8823 39.9996V10.5996H64.4903L63.4403 35.5476C63.3143 38.5716 62.9363 39.4956 61.2983 39.4956H61.1723V40.2516H61.2563C62.9363 40.2516 64.0703 39.2856 64.1963 36.7656L65.2463 11.4396H71.0423V40.0416L71.8823 39.9996ZM78.6466 39.9996V10.5996H77.8066V39.9996H78.6466ZM88.9406 24.4596L93.3926 10.5996H92.5946L88.2686 24.0816H85.4126V10.5996H84.5726V39.9996H85.4126V24.8376H88.2686L92.8466 39.9996H93.6446L88.9406 24.4596ZM101.204 39.9996L106.58 10.5996H105.782L102.002 31.1376L98.2643 10.5996H97.4663L101.582 33.1536L100.322 39.9996H101.204ZM111.435 10.6416V39.9996H116.349C118.953 39.9996 120.507 38.9076 120.507 36.3036V27.1476C120.507 25.3836 119.793 24.3336 118.533 23.7876C119.667 23.2416 120.297 22.1916 120.297 20.5536V14.3376C120.297 11.7336 118.743 10.6416 116.139 10.6416H111.435ZM112.275 11.3976H116.181C118.701 11.3976 119.457 12.2376 119.457 15.3456V19.5036C119.457 22.5276 118.785 23.4096 116.433 23.4516H112.275V11.3976ZM112.275 24.2076H116.391C118.911 24.2496 119.667 25.0476 119.667 28.1556V35.2957C119.667 38.4037 118.911 39.2436 116.391 39.2436H112.275V24.2076ZM133.737 39.9996L129.663 10.5996H128.361L124.287 39.9996H125.043L126.513 29.3316H131.511L132.981 39.9996H133.737ZM128.949 11.5236H129.033L129.705 16.4796L131.385 28.5336H126.639L128.319 16.4796L128.949 11.5236ZM147.697 39.9996V10.5996H146.857V23.6196H139.465V10.5996H138.625V39.9996H139.465V24.4596H146.857V39.9996H147.697ZM162.707 39.9996V10.5996H161.867V23.6196H154.475V10.5996H153.635V39.9996H154.475V24.4596H161.867V39.9996H162.707ZM177.035 39.9996V10.6416H172.121C169.517 10.6416 168.005 11.7336 168.005 14.3376V21.1416C168.005 22.8216 168.635 23.8716 169.811 24.4176C168.677 24.9636 168.005 26.0136 168.005 27.6936V40.0416H168.845V28.7436C168.845 25.8036 169.475 24.9216 171.659 24.7956H176.195V40.0416L177.035 39.9996ZM176.195 11.3976V24.0396H171.659C169.475 23.9556 168.845 23.0316 168.845 20.0916V15.3456C168.845 12.2376 169.559 11.3976 172.121 11.3976H176.195ZM203.58 39.9996V10.5996H202.11L197.238 39.5376H197.154L192.282 10.5996H190.812V39.9996H191.652V11.8176H191.736L196.482 39.9996H197.91L202.698 11.8176H202.782V39.9996H203.58ZM213.38 10.3896C210.818 10.3896 209.306 11.5236 209.306 14.0436V36.5976C209.306 39.1596 210.818 40.2516 213.38 40.2516H214.262C216.824 40.2516 218.378 39.1596 218.378 36.5976V14.0436C218.378 11.4816 216.824 10.3896 214.262 10.3896H213.38ZM214.262 11.1456C216.782 11.1456 217.538 11.9856 217.538 15.0936V35.5476C217.538 38.6556 216.782 39.4956 214.262 39.4956H213.38C210.86 39.4956 210.146 38.6556 210.146 35.5476V15.0936C210.146 11.9856 210.86 11.1456 213.38 11.1456H214.262ZM234.365 24.4596L238.397 10.5996H237.599L233.693 24.0816H231.257V10.5996H230.417V24.0816H227.981L224.075 10.5996H223.277L227.267 24.4596L223.025 39.9996H223.823L227.981 24.8376H230.417V39.9996H231.257V24.8376H233.651L237.809 39.9996H238.607L234.365 24.4596ZM252.126 11.4396V10.5996H243.474V39.9996H252.126V39.2016H244.314V24.4596H251.496V23.6196H244.314V11.4396H252.126ZM273.639 11.4396V10.5996H264.987V39.9996H269.901C272.505 39.9996 274.059 38.9076 274.059 36.3036V27.1476C274.059 24.5856 272.505 23.4516 269.901 23.4516H265.827V11.4396H273.639ZM265.827 24.2496H269.943C272.463 24.2496 273.219 25.0476 273.219 28.1556V35.2957C273.219 38.4037 272.463 39.2436 269.943 39.2436H265.827V24.2496ZM281.578 39.9996L286.954 10.5996H286.156L282.376 31.1376L278.638 10.5996H277.84L281.956 33.1536L280.696 39.9996H281.578ZM299.41 11.4396V10.5996H290.758V11.4396H294.664V39.9996H295.504V11.4396H299.41ZM313.138 39.9996V10.5996H311.668L304.99 39.2436L304.948 10.5996H304.108V39.9996H305.578L312.256 11.3556H312.34V39.9996H313.138Z"
              fill="#3F4C56"/>
          <path
              d="M15.0529 77.4377V48.1681H14.2167V76.6432H8.98996V48.1681H8.15369V76.6432H2.92698V48.1681H2.0907V77.4377H15.0529ZM22.3759 61.9666L26.8081 48.1681H26.0137L21.7069 61.5903H18.8635V48.1681H18.0273V77.4377H18.8635V62.343H21.7069L26.2646 77.4377H27.059L22.3759 61.9666ZM29.8184 77.4377V48.1681H28.9821V77.4377H29.8184ZM42.5337 76.6432V48.1681H35.1326L34.0873 72.7546C33.9619 75.5143 33.6692 76.476 32.3729 76.6432H31.7457V76.8523V82.8317H32.582V77.4377H42.6173V82.8317H43.4536V76.6432H42.5337ZM35.8853 49.0044H41.6974V76.6432H33.9619C34.4636 76.0997 34.7981 75.2634 34.84 74.009L35.8853 49.0044ZM54.9964 77.4377V48.1681H47.6372L46.5919 73.0054C46.4664 76.016 46.0901 76.9359 44.4594 76.9359H44.3339V77.6886H44.4176C46.0901 77.6886 47.2191 76.7269 47.3445 74.218L48.3899 49.0044H54.1602V77.4795L54.9964 77.4377ZM66.832 77.4377V48.1681H65.3685L58.7201 76.6851L58.6783 48.1681H57.8421V77.4377H59.3055L65.9539 48.9208H66.0375V77.4377H66.832ZM69.6574 48.2099V77.4377H74.5496C77.142 77.4377 78.6891 76.3505 78.6891 73.7581V64.6427C78.6891 62.8865 77.9783 61.8412 76.7239 61.2976C77.8528 60.754 78.48 59.7087 78.48 58.078V51.8895C78.48 49.2971 76.9329 48.2099 74.3405 48.2099H69.6574ZM70.4936 48.9626H74.3823C76.8911 48.9626 77.6438 49.7989 77.6438 52.8931V57.0326C77.6438 60.0432 76.9748 60.9213 74.6332 60.9631H70.4936V48.9626ZM70.4936 61.7158H74.5914C77.1002 61.7576 77.8528 62.552 77.8528 65.6462V72.7546C77.8528 75.8488 77.1002 76.6851 74.5914 76.6851H70.4936V61.7158ZM89.4359 77.4377V48.1681H87.9724L81.324 76.6851L81.2822 48.1681H80.4459V77.4377H81.9094L88.5578 48.9208H88.6414V77.4377H89.4359ZM104.847 77.4377V48.1681H103.384L98.5333 76.9777H98.4497L93.5993 48.1681H92.1358V77.4377H92.9721V49.3807H93.0557L97.7807 77.4377H99.2023L103.969 49.3807H104.053V77.4377H104.847ZM123.845 76.6432V48.1681H116.444L115.399 72.7546C115.273 75.5143 114.98 76.476 113.684 76.6432H113.057V76.8523V82.8317H113.893V77.4377H123.929V82.8317H124.765V76.6432H123.845ZM117.197 49.0044H123.009V76.6432H115.273C115.775 76.0997 116.109 75.2634 116.151 74.009L117.197 49.0044ZM136.308 77.4377V48.1681H128.949L127.903 73.0054C127.778 76.016 127.401 76.9359 125.771 76.9359H125.645V77.6886H125.729C127.401 77.6886 128.53 76.7269 128.656 74.218L129.701 49.0044H135.471V77.4795L136.308 77.4377ZM147.223 77.4377V48.2099H142.331C139.739 48.2099 138.233 49.2971 138.233 51.8895V58.6634C138.233 60.3359 138.861 61.3812 140.031 61.9248C138.902 62.4684 138.233 63.5137 138.233 65.1863V77.4795H139.07V66.2316C139.07 63.3047 139.697 62.4266 141.871 62.3011H146.387V77.4795L147.223 77.4377ZM146.387 48.9626V61.5485H141.871C139.697 61.4649 139.07 60.545 139.07 57.618V52.8931C139.07 49.7989 139.781 48.9626 142.331 48.9626H146.387ZM156.465 48.2099V77.4377H161.357C163.95 77.4377 165.497 76.3505 165.497 73.7581V64.6427C165.497 62.8865 164.786 61.8412 163.531 61.2976C164.66 60.754 165.288 59.7087 165.288 58.078V51.8895C165.288 49.2971 163.74 48.2099 161.148 48.2099H156.465ZM157.301 48.9626H161.19C163.699 48.9626 164.451 49.7989 164.451 52.8931V57.0326C164.451 60.0432 163.782 60.9213 161.441 60.9631H157.301V48.9626ZM157.301 61.7158H161.399C163.908 61.7576 164.66 62.552 164.66 65.6462V72.7546C164.66 75.8488 163.908 76.6851 161.399 76.6851H157.301V61.7158ZM175.742 77.4377L171.686 48.1681H170.389L166.334 77.4377H167.086L168.55 66.817H173.526L174.989 77.4377H175.742ZM170.975 49.088H171.058L171.728 54.022L173.4 66.0226H168.675L170.348 54.022L170.975 49.088ZM190.643 77.4377V48.1681H189.806V76.6432H184.58V48.1681H183.743V76.6432H178.517V48.1681H177.68V77.4377H190.643ZM197.464 47.959C194.913 47.959 193.408 49.088 193.408 51.5968V74.0508C193.408 76.6014 194.913 77.6886 197.464 77.6886H198.342C200.893 77.6886 202.44 76.6014 202.44 74.0508V51.5968C202.44 49.0462 200.893 47.959 198.342 47.959H197.464ZM198.342 48.7117C200.851 48.7117 201.603 49.548 201.603 52.6422V73.0054C201.603 76.0997 200.851 76.9359 198.342 76.9359H197.464C194.955 76.9359 194.244 76.0997 194.244 73.0054V52.6422C194.244 49.548 194.955 48.7117 197.464 48.7117H198.342ZM213.798 49.0044V48.1681H205.184V77.4377H206.021V49.0044H213.798ZM219.169 47.959C216.619 47.959 215.113 49.088 215.113 51.5968V74.0508C215.113 76.6014 216.619 77.6886 219.169 77.6886H220.047C222.598 77.6886 224.145 76.6014 224.145 74.0508V51.5968C224.145 49.0462 222.598 47.959 220.047 47.959H219.169ZM220.047 48.7117C222.556 48.7117 223.309 49.548 223.309 52.6422V73.0054C223.309 76.0997 222.556 76.9359 220.047 76.9359H219.169C216.661 76.9359 215.95 76.0997 215.95 73.0054V52.6422C215.95 49.548 216.661 48.7117 219.169 48.7117H220.047ZM236.214 47.959C233.622 47.959 232.117 49.0462 232.117 51.5968V54.2729H232.953V52.6422C232.953 49.548 233.664 48.7117 236.214 48.7117H237.051C239.559 48.7117 240.27 49.548 240.27 52.6422V57.0326C240.27 60.0432 239.601 60.9213 237.302 60.9631H234.249V61.7158H237.26C239.769 61.7576 240.479 62.552 240.479 65.6462V73.0054C240.479 76.0997 239.769 76.9359 237.26 76.9359H236.214C233.664 76.9359 232.953 76.0997 232.953 73.0054V71.3747H232.117V74.0508C232.117 76.6014 233.622 77.7304 236.214 77.6886H237.26C239.81 77.7304 241.316 76.6014 241.316 74.0508V64.6427C241.316 62.8865 240.605 61.8412 239.392 61.2976C240.479 60.754 241.107 59.7087 241.107 58.078V51.6387C241.107 49.088 239.601 47.959 237.051 47.959H236.214ZM253.002 76.6432V48.1681H245.601L244.556 72.7546C244.43 75.5143 244.137 76.476 242.841 76.6432H242.214V76.8523V82.8317H243.05V77.4377H253.086V82.8317H253.922V76.6432H253.002ZM246.354 49.0044H252.166V76.6432H244.43C244.932 76.0997 245.266 75.2634 245.308 74.009L246.354 49.0044ZM259.694 47.959C257.144 47.959 255.638 49.088 255.638 51.5968V74.0508C255.638 76.6014 257.144 77.6886 259.694 77.6886H260.572C263.123 77.6886 264.67 76.6014 264.67 74.0508V51.5968C264.67 49.0462 263.123 47.959 260.572 47.959H259.694ZM260.572 48.7117C263.081 48.7117 263.834 49.548 263.834 52.6422V73.0054C263.834 76.0997 263.081 76.9359 260.572 76.9359H259.694C257.186 76.9359 256.475 76.0997 256.475 73.0054V52.6422C256.475 49.548 257.186 48.7117 259.694 48.7117H260.572ZM267.415 48.2099V77.4377H268.251V62.7193H272.307C274.9 62.7193 276.447 61.5903 276.447 59.0397V51.8895C276.447 49.2971 274.9 48.2099 272.307 48.2099H267.415ZM268.251 48.9626H272.349C274.858 48.9626 275.61 49.7989 275.61 52.8931V58.0361C275.61 61.1304 274.858 61.9666 272.349 61.9666H268.251V48.9626ZM282.625 47.959C280.074 47.959 278.569 49.088 278.569 51.5968V74.0508C278.569 76.6014 280.074 77.6886 282.625 77.6886H283.503C286.054 77.6886 287.601 76.6014 287.601 74.0508V51.5968C287.601 49.0462 286.054 47.959 283.503 47.959H282.625ZM283.503 48.7117C286.012 48.7117 286.765 49.548 286.765 52.6422V73.0054C286.765 76.0997 286.012 76.9359 283.503 76.9359H282.625C280.116 76.9359 279.405 76.0997 279.405 73.0054V52.6422C279.405 49.548 280.116 48.7117 282.625 48.7117H283.503ZM290.345 48.2099V77.4377H295.238C297.83 77.4377 299.377 76.3505 299.377 73.7581V64.6427C299.377 62.8865 298.666 61.8412 297.412 61.2976C298.541 60.754 299.168 59.7087 299.168 58.078V51.8895C299.168 49.2971 297.621 48.2099 295.029 48.2099H290.345ZM291.182 48.9626H295.07C297.579 48.9626 298.332 49.7989 298.332 52.8931V57.0326C298.332 60.0432 297.663 60.9213 295.321 60.9631H291.182V48.9626ZM291.182 61.7158H295.279C297.788 61.7576 298.541 62.552 298.541 65.6462V72.7546C298.541 75.8488 297.788 76.6851 295.279 76.6851H291.182V61.7158ZM301.887 51.7223L302.848 48.1681H301.845L301.259 51.7223H301.887ZM313.707 77.4377V48.2099H308.815C306.223 48.2099 304.717 49.2971 304.717 51.8895V58.6634C304.717 60.3359 305.344 61.3812 306.515 61.9248C305.386 62.4684 304.717 63.5137 304.717 65.1863V77.4795H305.554V66.2316C305.554 63.3047 306.181 62.4266 308.355 62.3011H312.871V77.4795L313.707 77.4377ZM312.871 48.9626V61.5485H308.355C306.181 61.4649 305.554 60.545 305.554 57.618V52.8931C305.554 49.7989 306.264 48.9626 308.815 48.9626H312.871Z"
              fill="#3F4C56"/>
        </svg>


      </footer>

    </div>
    <script type="application/ld+json">
        {
        "@context": "https://schema.org",
        "@type": "BreadcrumbList",
        "itemListElement": [{
            "@type": "ListItem",
            "position": 1,
            "name": "Вакцинація перед школою",
            "item": "https://d3r65du9m6q6hf.cloudfront.net/pertussis"
        },{
            "@type": "ListItem",
            "position": 2,
            "name": "Кашлюк",
            "item": "https://d3r65du9m6q6hf.cloudfront.net/pertussis#ka2"
        },{
            "@type": "ListItem",
            "position": 3,
            "name": "Дифтерія",
            "item": "https://d3r65du9m6q6hf.cloudfront.net/pertussis#section2"
        },{
            "@type": "ListItem",
            "position": 4,
            "name": "Правець",
            "item": "https://d3r65du9m6q6hf.cloudfront.net/pertussis#section3"
        }]
        }
    </script>
    <script type="application/ld+json">
    {
      "@context": "https://schema.org",
      "@type": "Organization",
      "url": "https://d3r65du9m6q6hf.cloudfront.net",
      "logo": "https://d3r65du9m6q6hf.cloudfront.net/logo.png"
    }
    </script>

    <bottomBlockPert class="btm_block"></bottomBlockPert>
    </div>
</template>
<script>
import Parallax from 'parallax-js';
import {gsap, TweenMax, TimelineMax} from "gsap";
import Header from '../components/main-header.vue';
import BottomBlock from '../components/pertussis/pertussis-header-bottom-block.vue';

export default {
    metaInfo() {
        return{
            meta: [
                { vmid: 'description', name: 'description', content: 'Що таке коклюш? Які симптоми захворювання? Які профілактичні засоби для запобігання зараженням коклюшу? Про все це дізнайтеся на VaccinesHUB' },
                { vmid: 'og:description', property: 'og:description', content: 'Що таке коклюш? Які симптоми захворювання? Які профілактичні засоби для запобігання зараженням коклюшу? Про все це дізнайтеся на VaccinesHUB'},
                { vmid: 'og:site_name', property: 'og:site_name', content: 'Коклюш: симптоми, профілактика, вакцинація | VaccinesHUB'},
                { vmid: 'og:title', property: 'og:title', content: 'Коклюш: симптоми, профілактика, вакцинація | VaccinesHUB'},
                { vmid: 'og:image', property: 'og:image', content: 'https://vuejsdynamicmeta.z13.web.core.windows.net/img/girl_and_mom.d33e4d02.png'},
                { vmid: 'twitter:image', property: 'twitter:image', content: 'https://vuejsdynamicmeta.z13.web.core.windows.net/img/girl_and_mom.d33e4d02.png'},
                { property: 'og:type', content: 'website'}
            ]
        }
    },
    name: "pertussis",
    data(){
        return {
            showLinks: false,
            anchorPressed: false,
            myTlA1: new TimelineMax({delay: 0.1}),
            myTlA2: new TimelineMax({delay: 0.1}),
            myTlA3: new TimelineMax({delay: 0.1}),
            myTlA4: new TimelineMax({delay: 0.1}),
            myTlA5: new TimelineMax({delay: 0.1}),
            myTlA6: new TimelineMax({delay: 0.1}),
            myTlA7: new TimelineMax({delay: 0.1}),
            myTlA8: new TimelineMax({delay: 0.1}),
            myTlA9: new TimelineMax({delay: 0.1}),
            myTlA10: new TimelineMax({delay: 0.1}),
            myTlA11: new TimelineMax({delay: 0.1}),
            myTlA12: new TimelineMax({delay: 0.1}),
            myTlA13: new TimelineMax({delay: 0.1}),
            myTlA14: new TimelineMax({delay: 0.1}),
            myTlA15: new TimelineMax({delay: 0.1}),


        }
    },
    components: {
        Header,
        BottomBlock,
    },
    methods: {
        goToMob(where){
            this.closeMenu();
            this.$router.push({ path: 'pertussis#' + where })
        },
        closeMenu(){
            document.body.style.overflow = 'unset';
            this.anchorPressed = false;
        },
        openMenu(){
            this.anchorPressed = true;
            document.body.style.overflow = 'hidden';
        },
        animation1() {
            this.myTlA1
                .to(['.small_orange_ellipse', '.big_blue_ellipse', '.big_half_blue_ellipse', '.small_blue_ellipse', '.big_orange_ellipse ', '.small_half_blue_ellipse'], 0.7, {opacity: 1})
                .to(['#anim1', '#anim3'], 0.5, { opacity: 1, y: -5})
                .to('#anim2', 0.5, {opacity: 1, y: -5});
            },
        animation1_saf() {
            this.myTlA1
                .to(['.small_orange_ellipse', '.big_blue_ellipse', '.big_half_blue_ellipse', '.small_blue_ellipse', '.big_orange_ellipse ', '.small_half_blue_ellipse'], 0.7, {y: -10})
                .to(['#anim1', '#anim3'], 0.5, {  y: -5})
                .to('#anim2', 0.5, { y: -5});
            },
        animation2(){
            this.myTlA2
                .to('#stage2', 1, { opacity: 1, y: -5});
        },
        animation2_saf(){
            this.myTlA2
                .to('#stage2', 1, { y: -5});
        },
        animation3(){
            this.myTlA3
                .to('#stage3', 1, {opacity: 1, y: -5});
        },
        animation3_saf(){
            this.myTlA3
                .to('#stage3', 1, { y: -5});
        },
        animation4(){
            this.myTlA4
                .to('#stage4', 1, {opacity: 1, y: -5});
        },
        animation4_saf(){
            this.myTlA4
                .to('#stage4', 1, {y: -5});
        },
        animation5(){
            this.myTlA5
                .to('#stage5', 1, {opacity: 1, y: -5});
        },
        animation5_saf(){
            this.myTlA5
                .to('#stage5', 1, { y: -25});
        },
        animation6(){
            this.myTlA6
                .to('#stage6', 1, {opacity: 1,  y: -5});
        },
        animation6_saf(){
            TweenMax.myTlA6
                .to('#stage6', 1, {  y: -5});
            
        },
        animation7(){
            this.myTlA7
                .to('#section1', .3, {y: -5,opacity: 1});
        },
        animation7_saf(){
            this.myTlA7
                .to('#section1', 1, { y: -5});
        },
        animation8(){
            this.myTlA8
                .to('#ka2item1', .3, {y:-5, opacity: 1})
                .to('#ka2item2', .3, {y:-5, opacity: 1})
                .to('#ka2item3', .3, {y:-5, opacity: 1})
                .to('#ka2item4', .3, {y:-5, opacity: 1})
        },
        animation8_saf(){
            this.myTlA8
                .to('#ka2item1', .3, {y: -5})
                .to('#ka2item2', .3, {y: -5})
                .to('#ka2item3', .3, {y: -5})
                .to('#ka2item4', .3, {y: -5})
        },
        animation9(){
            this.myTlA9
                .to('.fst ', .3, {y:-5, opacity: 1})
                .to('.main_info_text1', .3, {y:-5, opacity: 1})
                .to('.main_info_1_labels', .3, {y:-5, opacity: 1})
        },
        animation9_saf(){
            this.myTlA9
                .to('.fst ', .3, {y: -5})
                .to('.main_info_text1', .3, {y: -5})
                .to('.main_info_1_labels', .3, {y: -5})
        },
        animation10(){
            this.myTlA10
                .to('#symb1', .3, {x:0, opacity: 1})
                .to('#symb2', .3, {x:0, opacity: 1})
                .to('#symb3', .3, {x:0, opacity: 1})
                .to('#symb4', .3, {x:0, opacity: 1})
                .to('#symb5', .3, {x:0, opacity: 1})
        },
        animation10_saf(){
            this.myTlA10
                .to('#symb1', .3, {y: -5})
                .to('#symb2', .3, {y: -5})
                .to('#symb3', .3, {y: -5})
                .to('#symb4', .3, {y: -5})
                .to('#symb5', .3, {y: -5})
        },
        animation11(){
            this.myTlA11
                .to('#dis1', .3, {y:-5, opacity: 1})
                .to('#dis2', .3, {y:-5, opacity: 1})
                .to('#dis3', .3, {y:-5, opacity: 1})
        },
        animation11_saf(){
            this.myTlA11
                .to('#dis1', .3, {y: -5})
                .to('#dis2', .3, {y: -5})
                .to('#dis3', .3, {y: -5})
        },
        animation12(){
            this.myTlA12
                .to('#dit1', .3, {y:-5, opacity: 1})
                .to('#dit2', .3, {y:-5, opacity: 1})
                .to('#dit3', .3, {y:-5, opacity: 1})
        },
        animation12_saf(){
            this.myTlA12
                .to('#dit1', .3, {y: -5})
                .to('#dit2', .3, {y: -5})
                .to('#dit3', .3, {y: -5})
        },
        animation13(){
            this.myTlA13
                .to('#pra1', .3, {y:-5, opacity: 1})
                .to('#pra2', .3, {y:-5, opacity: 1})
                .to('#pra3', .3, {y:-5, opacity: 1})
        },
        animation13_saf(){
            this.myTlA13
                .to('#pra1', .3, {y: -5})
                .to('#pra2', .3, {y: -5})
                .to('#pra3', .3, {y: -5})
        },
       animation14(){
            this.myTlA14
                .to('#pta1', .3, {y:-5, opacity: 1})
                .to('#pta2', .3, {y:-5, opacity: 1})
        },
       animation14_saf(){
            this.myTlA14
                .to('#pta1', .3, {y: -5})
                .to('#pta2', .3, {y: -5})
        },
        safToAnimation(){
            this.myTlA15
                TweenMax.to('#pta1', 0, {y: 5})
                TweenMax.to('#pta2', 0, {y: 5})
                TweenMax.to('#pra1', 0, {y: 5})
                TweenMax.to('#pra2', 0, {y: 5})
                TweenMax.to('#pra3', 0, {y: 5})
                TweenMax.to('#dit1', 0, {y: 5})
                TweenMax.to('#dit2', 0, {y: 5})
                TweenMax.to('#dit3', 0, {y: 5})
                TweenMax.to('#dis1', 0, {y: 5})
                TweenMax.to('#dis2', 0, {y: 5})
                TweenMax.to('#dis3', 0, {y: 5})
                TweenMax.to('#symb1', 0, {y: 5})
                TweenMax.to('#symb2', 0, {y: 5})
                TweenMax.to('#symb3', 0, {y: 5})
                TweenMax.to('#symb4', 0, {y: 5})
                TweenMax.to('#symb5', 0, {y: 5})
                TweenMax.to('.fst ', 0, {y: 5})
                TweenMax.to('.main_info_text1', 0, {y: 5})
                TweenMax.to('.main_info_1_labels', 0, {y: 5})
                TweenMax.to('#ka2item1', 0, {y: 5})
                TweenMax.to('#ka2item2', 0, {y: 5})
                TweenMax.to('#ka2item3', 0, {y: 5})
                TweenMax.to('#ka2item4', 0, {y: 5})
                TweenMax.to('#section1', 0, { y: 5})
                TweenMax.to('#stage6', 0, { y: 5})
                TweenMax.to('#stage5', 0, { y: 5})
                TweenMax.to('#stage4', 0, { y: 5})
                TweenMax.to('#stage3', 0, { y: 5})
                TweenMax.to('#stage2', 0, { y: 5})
                TweenMax.to(['.small_orange_ellipse', '.big_blue_ellipse', '.big_half_blue_ellipse', '.small_blue_ellipse', '.big_orange_ellipse ', '.small_half_blue_ellipse'], 0, {y: 5})
                TweenMax.to(['#anim1', '#anim3'], 0, {  y: 5})
                TweenMax.to('#anim2', 0, { y: 5});
        },
        ToAnimation(){
            this.myTlA15
                TweenMax.to('#pta1', 0, {y: 5,opacity:0})
                TweenMax.to('#pta2', 0, {y: 5, opacity:0})
                TweenMax.to('#pra1', 0, {y: 5, opacity:0})
                TweenMax.to('#pra2', 0, {y: 5, opacity:0})
                TweenMax.to('#pra3', 0, {y: 5, opacity:0})
                TweenMax.to('#dit1', 0, {y: 5, opacity:0})
                TweenMax.to('#dit2', 0, {y: 5, opacity:0})
                TweenMax.to('#dit3', 0, {y: 5, opacity:0})
                TweenMax.to('#dis1', 0, {y: 5, opacity:0})
                TweenMax.to('#dis2', 0, {y: 5, opacity:0})
                TweenMax.to('#dis3', 0, {y: 5, opacity:0})
                TweenMax.to('#symb1', 0, {y: 5, opacity:0})
                TweenMax.to('#symb2', 0, {y: 5, opacity:0})
                TweenMax.to('#symb3', 0, {y: 5, opacity:0})
                TweenMax.to('#symb4', 0, {y: 5, opacity:0})
                TweenMax.to('#symb5', 0, {y: 5, opacity:0})
                TweenMax.to('.fst ', 0, {y: 5, opacity:0})
                TweenMax.to('.main_info_text1', 0, {y: 5, opacity:0})
                TweenMax.to('.main_info_1_labels', 0, {y: 5, opacity:0})
                TweenMax.to('#ka2item1', 0, {y: 5, opacity:0})
                TweenMax.to('#ka2item2', 0, {y: 5, opacity:0})
                TweenMax.to('#ka2item3', 0, {y: 5, opacity:0})
                TweenMax.to('#ka2item4', 0, {y: 5, opacity:0})
                TweenMax.to('#section1', 0, { y: 5, opacity: 0})
                TweenMax.to('#stage6', 0, { y: 5, opacity: 0})
                TweenMax.to('#stage5', 0, { y: 5, opacity: 0})
                TweenMax.to('#stage4', 0, { y: 5, opacity: 0})
                TweenMax.to('#stage3', 0, { y: 5, opacity: 0})
                TweenMax.to('#stage2', 0, { y: 5, opacity:0})
                TweenMax.to(['.small_orange_ellipse', '.big_blue_ellipse', '.big_half_blue_ellipse', '.small_blue_ellipse', '.big_orange_ellipse ', '.small_half_blue_ellipse'], 0, {y: 5})
                TweenMax.to(['#anim1', '#anim3'], 0, {  y: 10 , opacity:0})
                TweenMax.to('#anim2', 0, { y: 20, opacity: 0});
        },
        withoutAnimation(){
            document.getElementById('ka2item1').style.opacity = 1;
            document.getElementById('ka2item2').style.opacity = 1;
            document.getElementById('ka2item3').style.opacity = 1;
            document.getElementById('ka2item4').style.opacity = 1;
            document.getElementsByClassName('fst')[0].style.opacity = 1;
            document.getElementsByClassName('fst')[1].style.opacity = 1;
            document.getElementsByClassName('main_info_text1')[0].style.opacity = 1;
            document.getElementsByClassName('main_info_1_labels')[0].style.opacity = 1;
            document.getElementById('symb1').style.opacity = 1;
            document.getElementById('symb2').style.opacity = 1;
            document.getElementById('symb3').style.opacity = 1;
            document.getElementById('symb4').style.opacity = 1;
            document.getElementById('symb5').style.opacity = 1;
            document.getElementById('dis1').style.opacity = 1;
            document.getElementById('dis2').style.opacity = 1;
            document.getElementById('dis3').style.opacity = 1;
            document.getElementById('dit1').style.opacity = 1;
            document.getElementById('dit2').style.opacity = 1;
            document.getElementById('dit3').style.opacity = 1;
            document.getElementById('pra1').style.opacity = 1;
            document.getElementById('pra2').style.opacity = 1;
            document.getElementById('pra3').style.opacity = 1;
            document.getElementById('pta1').style.opacity = 1;
            document.getElementById('pta2').style.opacity = 1;
        },
        toTop() {
            const link = document.querySelectorAll('.bottom-list__item');
            link.forEach((a) => {
                a.classList.remove('active-link')
            });
            document.body.scrollTop = 0;
            document.documentElement.scrollTop = 0;
        }
    },
    mounted(){
        //this.setAllToAnimation();
        this.animation1();
        const headings = document.querySelectorAll('.anchorTag');
        let dele = true;
        let safari = false;
       if((navigator.userAgent.indexOf("Opera") || navigator.userAgent.indexOf('OPR')) != -1 ) 
        {
            console.log('Opera');
        }
        else if(navigator.userAgent.indexOf("Chrome") != -1 )
        {
            console.log('Chrome');
        }
        else if(navigator.userAgent.indexOf("Safari") != -1)
        {
            console.log('Safari');
            safari = true;
            //this.withoutAnimation();

        }
        else if(navigator.userAgent.indexOf("Firefox") != -1 ) 
        {
            console.log('Firefox');
        }
        if ( safari ){
            dele = false;
            this.withoutAnimation();
            this.safToAnimation();
        }
        else{
            this.ToAnimation();
        }
        
            document.addEventListener('scroll', (e) => {
                
                    headings.forEach(ha => {
                        const rect = ha.getBoundingClientRect();
                        let wid = 450;
                        if(window.screen.width < 1000){
                            wid = 300;
                        }
                        if (rect.top > 0 && rect.top < wid) {
                        const location = window.location.toString().split('#')[0];
                        history.replaceState(null, null, location + '#' + ha.id);
                        if(dele){
                            if (ha.id === 'stage1') {
                            } else if (ha.id === 'stage2') {
                                this.animation2()
                            } else if (ha.id === 'stage3') {
                                this.animation3()
                            } else if (ha.id === 'stage4') {
                                this.animation4()
                            } else if (ha.id === 'stage5') {
                                this.animation5()
                            } else if (ha.id === 'stage6') {
                                this.animation6()
                                this.animation7()
                            } else if (ha.id === 'section1') {
                                this.animation7()
                            } else if (ha.id === 'ka2') {
                                this.animation8();
                            } else if (ha.id === 'ka3') {
                                this.animation9()
                            }else if (ha.id === 'ka4') {
                                this.animation10()
                            } else if (ha.id === 'di1') {
                                this.animation11()
                            } else if (ha.id === 'di3') {
                                this.animation12()
                            }else if (ha.id === 'pa1') {
                                this.animation13()
                            }else if (ha.id === 'pa2') {
                                this.animation14()
                            }
                            }
                        else{
                             if (ha.id === 'stage1') {
                             } else if (ha.id === 'stage2') {
                                 this.animation2_saf()
                             } else if (ha.id === 'stage3') {
                                 this.animation3_saf()
                             } else if (ha.id === 'stage4') {
                                 this.animation4_saf()
                             } else if (ha.id === 'stage5') {
                                 this.animation5_saf()
                             } else if (ha.id === 'stage6') {
                                 this.animation6_saf()
                             } else if (ha.id === 'section1') {
                                 this.animation7_saf()
                             } else if (ha.id === 'ka2') {
                                 this.animation8_saf()
                             } else if (ha.id === 'ka3') {
                                 this.animation9_saf()
                             }else if (ha.id === 'ka4') {
                                 this.animation10_saf()
                             } else if (ha.id === 'di1') {
                                 this.animation11_saf()
                             } else if (ha.id === 'di3') {
                                 this.animation12_saf()
                             }else if (ha.id === 'pa1') {
                                 this.animation13_saf()
                             }else if (ha.id === 'pa2') {
                                 this.animation14_saf()
                             }
                         }
                        }
                    });
                
            });

        window.document.title = "Коклюш: симптоми, профілактика, вакцинація | VaccinesHUB";
        let allMetaElements = document.getElementsByTagName('meta');
        // for(let i = 0; i< allMetaElements.length; i++){
        //     if(allMetaElements[i].getAttribute("name") === "description"){
        //         allMetaElements[i].setAttribute('content', "Що таке коклюш? Які симптоми захворювання? Які профілактичні засоби для запобігання зараженням коклюшу? Про все це дізнайтеся на VaccinesHUB")
        //     }
        //     if(allMetaElements[i].getAttribute("property") === "og:description"){
        //         allMetaElements[i].setAttribute('content', "Що таке коклюш? Які симптоми захворювання? Які профілактичні засоби для запобігання зараженням коклюшу? Про все це дізнайтеся на VaccinesHUB")
        //     }
        //     if(allMetaElements[i].getAttribute("property") === "og:site_name"){
        //         allMetaElements[i].setAttribute('content', "Коклюш: симптоми, профілактика, вакцинація | VaccinesHUB")
        //     }
        //     if(allMetaElements[i].getAttribute("property") === "og:title"){
        //         allMetaElements[i].setAttribute('content', "Коклюш: симптоми, профілактика, вакцинація | VaccinesHUB")
        //     }
        //     // if(allMetaElements[i].getAttribute("property") === "twitter:description"){
        //     //     allMetaElements[i].setAttribute('content', "Що таке коклюш? Які симптоми захворювання? Які профілактичні засоби для запобігання зараженням коклюшу? Про все це дізнайтеся на VaccinesHUB")
        //     // }
        //     // if(allMetaElements[i].getAttribute("property") === "twitter:site_name"){
        //     //     allMetaElements[i].setAttribute('content', "Коклюш: симптоми, профілактика, вакцинація | VaccinesHUB")
        //     // }
        //     // if(allMetaElements[i].getAttribute("property") === "twitter:title"){
        //     //     allMetaElements[i].setAttribute('content', "Коклюш: симптоми, профілактика, вакцинація | VaccinesHUB")
        //     // }
        // }
        //this.$router.push({path: 'pertussis'});
    }
}
</script>

<style scoped lang="scss">
$fontR: "Raleway-Regular";
$fontM: "Raleway-Medium";
$fontB: "Raleway-Bold";
.hidden_anchor{
    display: none;
}
.to-top {
    /*cursor: pointer;
    margin: 40px 0 0 auto;*/
    position: sticky;
    position: -webkit-sticky;
    z-index: 9;
    top: 78.5vh;
    padding: 0 10px;
    text-align: right;
    width: 68px;
    margin-right: 10%;
    margin-left: auto;
    & > svg {
      cursor: pointer;
    }

    @media screen and (max-width: 1240px) {
      margin-right: 1%;
    }
    @media screen and (max-width: 768px) {
      top: 68vh;
    }
}
.anchorIs{
    display: flex;
    max-height: 100vh;
    height: 100vh;
    flex-direction: column;
    margin-top: -4vh;
    transition: all 1s;
    z-index: 100000;

    .header1{
        position: fixed;
        width:100%;
        min-height: 35px;
        z-index:101000;
        .logo1{
            position: fixed;
            height: 30px;
            left:25%;
        }
    }
    .blue_anchor{
        .eli1{
            position: absolute;
            top:140px;
            right:0;
            z-index:100000;
        }
        .eli2{
            position: absolute;
            top:240px;
            left:30px;
            z-index:100000;
        }
        .eli3{
            position: absolute;
            top:320px;
            left:0;
            z-index:9;
        }
        .eli4{
            position: absolute;
            top:470px;
            right:20px;
            z-index:100000;
        }
        position: fixed;

        background-color: #01BBF5 ;
        min-height: 800px;
        width:100%;
        margin-top:35px;
        padding: 40px;
        z-index:101000;

        .men_close{
            margin-top:0;
            margin-bottom: 50px;
            z-index:101000;
            .rr12{
                margin-top:250px;
            }
            .close_but{
                background: none;
                color: inherit;
                border: none;
                padding: 0;
                cursor: pointer;
                outline: inherit;
                color:white;
                font-size: 65px;
                line-height: 65px;
                float:right;
                margin-top: -3vh;
            }
            .rr1{
                margin-top:6px;
            }
        }
        .rr2{

            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: space-between;
            height: 200px;
            z-index:220000;
            .btn_1{
                z-index:220000;
                background: none;
                color: inherit;
                border: none;
                padding: 0;
                cursor: pointer;
                outline: inherit;
                color:white;
                font-size:30px;
                line-height: 90px;
                font: $fontR;
            }
        }
    }
}
.btm_block{
    bottom:15vh;
    @media screen and (max-width: 1000px) {
        bottom:10vh;
    }
}
.samo{
    position:fixed;
    display: flex;
    justify-content: center;
    align-items: center;
    bottom:-10px;
    z-index:10999;
    width:100%;
    height: calc(15vh + 10px);
    background-color: #EFF1F3;
    .im{
        width:99.999%;
        height: calc(15vh + 10px);
        @media screen and (max-width: 1000px) {
            display: none;
        }
    }
    .im1{
        display: none;
        @media screen and (max-width: 1000px) {
            display: block;
        }
    }
}
.container{
    width:100%;
    display: flex;
    flex-direction: column;
}
/*.header{
    background-color: white;
    height: 9vh;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    position: fixed;
    top:0;
    bottom:0;
    right:0;
    left:0;
    z-index: 110000;
    .logo1{
        margin-right: 10vw;
    }
}*/
.big_section1{
    width: 100%;
    display: flex;
    flex-direction: column;
    min-height: calc(100vh - 175px);
    .blue_header{
        width: 100%;
        background-color: #01BBF5;
        border-bottom-right-radius: 30px;
        border-bottom-left-radius: 30px;
        display: flex;
        min-height: calc(100vh - 175px);
        @media (max-width: 540px) {
            min-height: 584px;
        }
        .desktop{
            width: 100%;
            display: flex;
            margin-top: 8%;
            @media screen and(max-width: 1000px) {
                display:none;
            }
            .left_block{
                width:65%;
                display: flex;
                flex-direction: column;
                z-index:2;
                .top{
                    margin-top:10vh;
                    margin-left: 15vw;
                }
                .bottom{
                    margin-left: 15vw;
                    margin-top:5vw;
                    margin-bottom: 10vh;
                    z-index: 2;
                    .subtext{
                        margin-top:2vw;
                    }
                }
            }
            .right_block{
                display:flex;
                justify-content: center;
                align-items: center;
                width: calc(50% - 15vw);
                margin-right: 15vw;
                z-index: 2;
                .girl_and_mom{
                    width: 30vw;
                    border-radius: 30px;
                }
            }
        }
        .mobile{
            display: none;
            width:100%;
            z-index:2;
            @media screen and(max-width: 1000px) {
                display:flex;
                flex-direction: column;
                justify-content: center;
            }
            @media (max-width: 540px) {
                    padding: 0 20px;
                }
            .top_block{
                padding-top:3%;
                padding-bottom:5%;

                display: flex;
                justify-content: space-around;
                @media screen and (max-width: 1000px) {
                    //margin-top: 3vh;
                    margin-top: 28px;
                }
                @media screen and (max-width: 768px) {
                    margin-top: 64px;
                }
            }
            .bottom_block{
                display: flex;
                flex-direction: column;
                align-items: center;
                padding: 5%;
                max-width: 100%;
                @media (max-width: 1000px) {
                    margin-top: 10%;
                }
                @media (max-width: 768px) {
                    margin-top: 20%;
                }
                @media (max-width: 540px) {
                    margin-top: 30%;
                    padding: 0;
                }
                @media (max-width: 360px) {
                    margin-top: 4%;
                }
                .girl_and_mom{
                    width:70%;
                    margin-top: 2%;
                    margin-bottom:2%;
                    border-radius: 30px;
                    @media (max-width: 540px) {
                        width: 100%;
                        margin-top: 8%;
                        margin-bottom:8%;
                    }
                }
            }
        }
    }
    .main_info{
        display:flex;
        flex-direction: column;
        padding-left:15vw;
        padding-right:30vw;
        padding-top: 10vh;
        @media screen and (max-width: 1000px) {
            padding-left:5vw;
            padding-right:5vw;
            padding-top: 10vh;
        }
        .head{
            margin-bottom: 5%;
            z-index: 10;
        }
        .text{
            display: flex;
            justify-content: space-between;
            @media screen and (max-width: 1000px) {
                flex-direction: column;
            }
            .first_sec{
                margin-right: 10%;
            }
        }
    }
    .orange_box1{
        background-color: #F4A032;
        margin-left: 15vw;
        margin-right: 15vw;
        margin-top: 10vh;
        border-radius: 30px;
        display: flex;
        justify-content: space-evenly;
        align-items: center;
        padding: 20px;
        @media screen and(max-width: 1000px) {
            flex-direction: column;
            padding: 20px;
            margin-left: 5vw;
            margin-right: 5vw;

        }
    }
    .after_orange_box{
        padding-left: 15vw;
        padding-right: 15vw;
        margin-top: 10vh;
        display: flex;
        justify-content: center;
        @media screen and (max-width: 1000px) {
            flex-direction:column;
            align-items: center;
            padding-left: 5vw;
            padding-right: 5vw;
            justify-content: flex-start;
        }
        .left_section{
            padding-right: 10%;
            width:65%;
            @media screen and (max-width: 1000px) {
                margin-bottom: 10vh;
                width:100%;
            }
            .main{
                display:flex;
                flex-direction: column;
                .img{
                    width:40%;
                    .medicine_icon{
                        width:100%;
                        margin-left: -11%;
                    }
                }
                @media screen and (max-width: 1000px) {
                    flex-direction: row;
                    align-items: center;
                    margin-bottom: 3vh;
                    .img{
                        width:60%;
                        .medicine_icon{
                            width:100%;
                        }
                    }
                }
            }
            .not_main{
                margin-top: 30px;
            }
        }
        .right_section{
            width:75%;
            @media screen and (max-width: 1000px) {
                width: 100%;
            }
            .tab_1{
                width: 100%;
            }
        }
    }
    .before_deseases{
        padding-left:15vw;
        padding-right: 15vw;
        margin-top: 10vh;
        display: flex;
        flex-direction: column;
        @media screen and (max-width: 1000px) {
            padding-left:5vw;
            padding-right: 5vw;
        }
        .head{
            margin-bottom: 7vh;
        }
        .counter{
            display:flex;
            flex-direction: column;
            .first_three{
                display:flex;
                justify-content: space-between;
                margin-bottom: 5vh;
                @media screen and (max-width: 1000px) {
                    flex-direction: column;
                    margin-bottom:0px;
                }
            }
            .second_three{
                display:flex;
                justify-content: space-between;
                @media screen and (max-width: 1000px) {
                    flex-direction: column;
                    margin-bottom:0px;
                }
            }
            .counting{
                width: 33vw;
                display: flex;
                align-items: center;
                @media screen and (max-width: 1000px) {
                    margin-bottom: 3vh;
                    width: 100%;
                }
                .number{
                    margin-right: 2vw;
                    font-size: 20px;
                    font-weight: 600;
                    font-family: $fontM;
                    border-radius: 30px;
                    border: solid 1px;
                    padding-left: 20px;
                    padding-right: 20px;
                    padding-top:14px;
                    padding-bottom: 14px;

                    background-color: #F4A032;
                }
            }
        }
    }
}
.big_section2{
    background-color: #F4A032;
    border-radius: 30px;
    padding-left: 15vw;
    padding-right: 15vw;
    padding-top: 10vh;
    padding-bottom: 10vh;
    margin-top: 10vh;
    z-index: 5;

    @media screen and (max-width: 1000px) {
        padding-left: 5vw;
        padding-right: 5vw;
        padding-top: 5vh;
        padding-bottom: 5vh;
    }
    .start_text{
        display:flex;
        width: 100%;
        z-index: 1000;
        @media screen and (max-width: 1000px) {
            flex-direction: column;
            justify-content: flex-start;
        }
        .left{
            width: 90vw;
            margin-right: 10vw;
        }
    }
    .pert{
        background-color: white;
        border-radius: 30px;
        padding-top: 10vh;
        padding-bottom: 10vh;
        padding-right: 5vw;
        padding-left: 5vw;
        margin-top: 10vh;
        z-index: 1000;

        @media screen and (max-width: 1000px) {
            padding-left: 5vw;
            padding-right: 5vw;
            padding-top: 5vh;
            padding-bottom: 5vh;
        }
        .sect_1{
            .desktop{
                display:flex;
                align-items: center;
                @media screen and (max-width: 1000px) {
                    display: none;
                }
                .left{
                    width: 70%;
                    .img_kashluk{
                        width: 100%;
                    }
                }
                .right{
                    width: 100%;
                    margin-left: 2vw;
                }
            }
            .mobile{
                display: none;
                padding: 10px;
                @media screen and (max-width: 1000px) {
                    display: flex;
                    flex-direction: column;
                }
                .img_kashluk{
                    width: 100%;
                    //margin-left: 10%;
                    margin-bottom: 3vh;
                }
            }
        }
        .sect_2{
            z-index: 1000;
            display: flex;
            .section1_box_counter{
                width:100%;
                margin-top:50px;
                min-height: 300px;
                font: $fontR;
                font-size: 23px;
                line-height: 29px;
                .section1_counter_item{
                    opacity:0;
                    float:left;
                    width:43%;
                    margin-left:5%;
                    margin-bottom: 40px;
                    @media screen and (max-width: 768px) {
                        width:90%;
                        float:none;
                        font-size: 16px;
                        line-height: 20px;
                    }
                }
            }
            .flexing{
                display: flex;
                flex-direction: column;
                width: 100%;
                margin-bottom: 5vh;
                .counting{
                    display: flex;
                    width: 100%;
                    margin-bottom: 5vh;
                    .text{
                        margin-left: 10px;
                    }
                }
            }
            @media screen and (max-width: 1000px) {
                flex-direction: column;
            }
        }
        .sect_3{
            z-index: 1000;
            display: flex;
            flex-direction: column;
            .fst{
                opacity:0;
                margin-bottom: 5vh;
                display: flex;
                align-items: center;
                margin-left: 2vw;
                @media screen and (max-width: 1000px) {
                    flex-direction: column;
                    align-items: flex-start;
                }
                .main_info_holder1{
                    .img11{
                        margin-left: -14%;
                    }
                    @media screen and (max-width: 1000px) {
                        margin-left: -1%;
                        @media screen and (max-width: 600px) {
                            margin-left: 0%;
                        }
                    }
                }
                
            }
            .main_info_text1{
                opacity: 0;
                margin-bottom: 5vh;
                margin-left: 2vw;
            }
            .main_info_1_labels{
                opacity: 0;
                display: flex;
                margin-left: 2vw;
                align-items: center;
                .img_dan{
                    margin-left:-3%;
                }
                .main_info1_danger_holder{
                    //margin-bottom: 5vh;
                    margin-right: 2vw;
                }
                @media screen and (max-width: 1000px) {
                    align-items: flex-start;
                    flex-direction: column;
                    .img_dan{
                        margin-left: -5%;
                        @media screen and (max-width: 600px) {
                            margin-left: -10%;
                        }
                    }
                    .main_info1_danger_holder{
                        margin-bottom: 5vh;
                        //margin-right: 2vw;
                    }
                }
            }
        }
        .sec_4{
            z-index: 1000;

            display: flex;
            flex-direction: column;
            margin-left: 2vw;
            .fst{
                display: flex;
                justify-content: space-between;
                @media screen and (max-width: 1350px) {
                    flex-direction: column;
                }
            }
            .scd{
                display: flex;
                justify-content: space-between;
                @media screen and (max-width: 1250px) {
                    flex-direction: column;
                }
            }
            .symbtoms1_item{
                opacity: 0;
                display: flex;
                align-items: center;
                width: 100%;
                margin-bottom: 10px;
                .symb1_item_img{
                    width:48%;
                    @media screen and (max-width: 1000px) {
                        width:30%;
                    }
                    .im_symb12{
                        width:10vw;
                        @media screen and (max-width: 600px) {
                            width: 20vw;
                        }
                    }
                }
            }
        }
        .sec_5{
            z-index: 1000;

            display: flex;
            flex-direction: column;
            padding-left: 2vw;
            padding-right: 2vw;
            .head2{
                display:flex;
                align-items: center;
                justify-content: space-between;
                margin-bottom: 5vh;
                @media screen and (max-width: 1000px) {
                    flex-direction: column;
                }
                .head2_img{
                    width:80%;
                    border-radius: 30px;
                    margin-right: 5vw;
                    @media screen and (max-width: 700px) {
                        //margin-right: 10vw;
                        width: 100%;
                        margin-right: 0px;
                    }
                    .typic_img_with_child{
                        width: 100%;
                        border-radius: 30px;
                    }
                }
            }
            .blue_rect1{
                padding: 20px;
                background-color: #01BBF5;
                border-radius: 30px;
                margin-top: 5vh;
                margin-bottom: 5vh;
            }
        }


    }

    .dift{
        background-color: white;
        border-radius: 30px;
        padding-top: 10vh;
        padding-bottom: 10vh;
        padding-right: 5vw;
        padding-left: 5vw;
        margin-top: 10vh;
        z-index: 1000;

        @media screen and (max-width: 1000px) {
            padding-left: 5vw;
            padding-right: 5vw;
            padding-top: 5vh;
            padding-bottom: 5vh;
        }
        .upper2{
            display:flex;
            align-items: flex-start;
            justify-content: space-evenly;
            @media screen and (max-width: 1000px) {
                display: none;
            }
            .img_holder_sec2{
                margin-right:3vw;
                width: 100%;

                .img_sec2{
                    width: 90%;
                }
            }
            .sec2_upper_rig{
                width:100%;
            }
        }
        .upper21{
            display: none;
            .sec2_upper_rig{
                .img_holder_sec2{
                    margin-top: 3vh;
                    margin-bottom: 5vh;
                    width: 96%;
                    margin-left: 2%;
                    .img_sec2{
                        width: 100%;
                    }
                }
            }

            @media screen and (max-width: 1000px) {
                display: flex;
                flex-direction: column;
            }
        }
        .osn_shl_per{
            display:flex;
            flex-direction: column;
            .counter{
                display: flex;
                justify-content: space-between;
                margin-top: 3vh;
                margin-bottom: 3vh;
                @media screen and (max-width: 1000px) {
                    flex-direction: column;
                }
                .shl_per{
                    opacity:0;
                    display: flex;
                    align-items: center;
                    .shl_per_holder{
                        display: flex;
                        align-items: center;
                        .shl_per_img{
                            width: 10vw;
                            height: auto;
                            @media screen and (max-width: 600px) {
                                width: 20vw;
                            }
                        }
                    }
                    @media screen and (max-width: 1150px) and (min-width: 1000px) {
                        flex-direction: column;
                    }
                    @media screen and (max-width: 1000px) {
                        margin-bottom: 1vh;
                    }
                }
                .shl_per1{
                    opacity:0;
                    display: flex;
                    align-items: center;
                    .shl_per_holder{
                        display: flex;
                        align-items: center;
                        .shl_per_img{
                            width: 10vw;
                            height: auto;
                            @media screen and (max-width: 600px) {
                                width: 20vw;
                            }
                        }
                    }
                    @media screen and (max-width: 1200px) and (min-width: 1000px) {
                        flex-direction: column;
                    }
                    @media screen and (max-width: 1000px) {
                        margin-bottom: 3vh;
                    }
                }
            }
        }
    }
    .pravec{
        z-index: 1000;

        background-color: white;
        border-radius: 30px;
        padding-top: 10vh;
        padding-bottom: 10vh;
        padding-right: 5vw;
        padding-left: 5vw;
        margin-top: 10vh;
        @media screen and (max-width: 1000px) {
            padding-left: 5vw;
            padding-right: 5vw;
            padding-top: 5vh;
            padding-bottom: 5vh;
        }
        .upper2{
            display:flex;
            align-items: flex-start;
            justify-content: space-evenly;
            @media screen and (max-width: 1000px) {
                display: none;
            }
            .img_holder_sec2{
                margin-right:3vw;
                width: 100%;
                .img_sec2{
                    width: 90%;
                }
            }
            .sec2_upper_rig{
                width:100%;
            }
        }
        .upper21{
            display: none;
            .sec2_upper_rig{
                .img_holder_sec2{
                    margin-top: 3vh;
                    margin-bottom: 5vh;
                    margin-left: 2%;
                    width: 96%;
                    .img_sec2{
                        width: 100%;
                    }
                }
            }

            @media screen and (max-width: 1000px) {
                display: flex;
                flex-direction: column;
            }
        }
        .osn_shl_per{
            display:flex;
            flex-direction: column;
            .counter{
                display: flex;
                justify-content: space-between;
                margin-top: 3vh;
                margin-bottom: 3vh;
                @media screen and (max-width: 1000px) {
                    flex-direction: column;
                }
                .shl_per{
                    opacity: 0;
                    display: flex;
                    align-items: center;
                    .shl_per_holder{
                        display: flex;
                        align-items: center;
                        .shl_per_img{
                            width: 10vw;
                            height: auto;
                            @media screen and (max-width: 600px) {
                                width: 20vw;
                            }
                        }
                    }
                    @media screen and (max-width: 1250px) and (min-width: 1000px) {
                        flex-direction: column;
                    }
                }
                .shl_per1{
                    display: flex;
                    align-items: center;
                    @media screen and (max-width: 1250px) and (min-width: 1000px) {
                        flex-direction: column;
                    }
                }
            }
            .counter1{
                display: flex;
                justify-content: space-evenly;
                margin-top: 3vh;
                margin-bottom: 3vh;
                @media screen and (max-width: 1000px) {
                    flex-direction: column;
                }
                .shl_per{
                    opacity:0;
                    display: flex;
                    align-items: center;
                    .shl_per_holder{
                        display: flex;
                        align-items: center;
                        .shl_per_img{
                            width: 10vw;
                            height: auto;
                            @media screen and (max-width: 600px) {
                                width: 20vw;
                            }
                        }
                    }
                    @media screen and (max-width: 1150px) and (min-width: 1000px) {
                        flex-direction: column;
                    }
                }
                .shl_per1{
                    display: flex;
                    align-items: center;
                    @media screen and (max-width: 1200px) and (min-width: 1000px) {
                        flex-direction: column;
                    }
                }
            }
        }
    }
}
.big_section3{
    display: flex;
    flex-direction: column;
    padding-left: 15vw;
    padding-right: 15vw;
    padding-top: 5vh;
    @media screen and (max-width: 1000px) {
        padding-left: 5vw;
        padding-right: 5vw;
        padding-top: 5vh;
    }
    .blue_smth{
        background-color: #01BBF5;
        border-radius: 30px;
        padding:10px;
        display:flex;
        align-items: center;
        margin-bottom: 5vh;
        @media screen and (max-width: 900px) {
            flex-direction: column;
            padding-bottom: 20px;

        }
    }
    .flexing{
        display: flex;
        .left_smth{
            margin-right: 3vw;
            width: 50%;
        }
        .right_smth{
            width: 60%;
            .tab2{
                width:100%;
            }
        }
        @media screen and (max-width: 1000px) {
            flex-direction: column;
            .left_smth{
                width: 100%;
                margin-bottom: 3vh;
            }
            .right_smth{
                width: 100%;
                margin-bottom: 3vh;
                .tab2{
                    width:100%;
                }
            }
        }
    }
}
.links-wrapper {
    display: flex;
    justify-content: center;
    
    .content {
      max-width: 1300px;
      width: 71%;
      padding: 30px 10px 30px 10px;
      @media screen and (max-width: 1000px) {
          width: 92%;
      }

      .show-hide-btn {
        cursor: pointer;
        color: #3F4C56;
        font-family: $fontM;
        font-size: 21px;
        display: flex;
        align-items: center;
        margin: 10px 0;

        &.active {
          svg {
            transform: rotate(180deg);
          }
        }

        svg {
          transition: transform .2s ease-in;
          margin-left: 5px;
          display: block;
        }
      }

      .hide-content {
        max-height: 0;
        overflow: hidden;
        transition: max-height .5s linear;

        &.active {
          max-height: 1000px;
        }

        .list {
          color: #3F4C56;
          font-family: $fontR;
          font-size: 14px;
          margin-bottom: 2px;

          @media screen and (max-width: 425px) {
            font-size: 12px;
          }

          a {
            text-decoration: none;
            color: #4D9BDE;
          }

          span {
            font-family: $fontB;
          }
        }
      }
    }
}
.font_text{
    font-family: $fontR;
    color:#344659;
}
.text_standart{
    font-size: 23px;
    line-height: 30px;
    @media screen and (max-width: 1000px) {
        font-size: 16px;
        line-height: 20px;
    }
}
.text_standart4{
    font-size: 18px;
    line-height: 22px;
    @media screen and (max-width: 1000px) {
        font-size: 14px;
        line-height: 20px;
    }
}
.text_standart2{
    font-size: 27px;
    line-height: 32px;
    @media screen and (max-width: 1000px) {
        font-size: 20px;
        line-height: 24px;
    }
}
.text_standart3{
    font-size: 14px;
    line-height: 18px;
    font-weight: 600;
    @media screen and (max-width: 1000px) {
        font-size: 12px;
        line-height: 27px;
    }
}
.text_32{
    font-size: 32px;
    line-height: 42px;
    @media screen and (max-width: 1000px) {
        font-size: 18px;
        line-height: 22px;
    }
}
.text-bold{
    font-family:$fontB;
    font-weight: 700;
}
.text-blue{
    color: #01BBF5;
}
.text-white{
    color: #FFFDFB;
}
.text-orange{
    color: #F4A032;
}
.text-colored{
    color: #344659;
}
.text-header{
    font-size: 72px;
    line-height: 93px;
    @media screen and (max-width: 1000px) {
        font-size: 30px;
        line-height: 39px;
    }
}
.text-firstheader{
    font-size: 72px;
    line-height: 76px;
    @media screen and (max-width: 1000px) {
        font-size: 48px;
        line-height: 51px;
    }
    @media screen and (max-width: 768px) {
        font-size: 30px;
        line-height: 33px;
    }
}
.text-subheader{
    font-size: 48px;
    line-height: 62px;
    @media screen and (max-width: 1000px) {
        font-size: 24px;
        line-height: 30px;
    }
}
.text-subheader2{
    font-size: 32px;
    line-height: 42px;
    @media screen and (max-width: 1000px) {
        font-size: 22px;
        line-height: 26px;
    }
}
.text-subheader3{
    font-size: 30px;
    line-height: 39px;
    @media screen and (max-width: 1000px) {
        font-size: 22px;
        line-height: 26px;
    }
}

.no_border{
    border: none;
}
.button1{
    color: white;
    font-family: $fontR;
    margin-left: 3vw;
    text-decoration: none;

    @media screen and (max-width: 1220px) {
        margin-left: 1vw;
    }
}
.link_meningit{
    color: white;
    font-family: $fontR;
    text-decoration: none;
    border: 2px solid white;
    border-radius: 30px;
    margin-right: 5%;
    padding-left: 20px;
    padding-right: 20px;
    padding-top: 5px;
    padding-bottom: 5px;
    @media screen and (max-width: 1100px) {
        margin-right: 0%;
        padding-left: 10px;
        padding-right: 10px;
    }
}
.link_meningit1{
    border: 1px solid white;
    border-radius: 30px;
    padding-left: 10px;
    padding-right: 10px;
    padding-top: 5px;
    padding-bottom: 5px;
    @media screen and (max-width: 1000px) {
        width: 20%;
        padding-left: 7px;
        padding-right: 7px;
        padding-top: 5px;
        padding-bottom: 5px;

    }
}
.link_meningit_logo{
    margin-right: 10px;
    // @media screen and (max-width: 1000px) {
    //     width: 10%;
    //     margin-right: 5px;
    // }
}
.divider{
    border-bottom: 3px solid #D2D2D2;
    margin-top: 5vh;
    margin-bottom: 5vh;
    width: 98%;
    margin-left: 1%;
    @media screen and (max-width: 1000px) {
        margin-top:3vh;
        margin-bottom:3vh;
        @media screen and (max-width: 600px) {
            margin-top:1.5vh;
            margin-bottom:1.5vh;
        }
    }
}
.orange_dot{
    background: #F4A032;
    height: 10px;
    width:10px;
    border-radius: 10px;
    margin-right: 5px;
    margin-top: 15px;
    display: inline-block;
}
//additional
.symbtoms1_text{
    margin-top:3vh;
    margin-bottom: 3vh;
}
.head2_text{
    margin-top:3vh;
    .head2_header{
        margin-bottom: 3vh; 
    } 
}
.sec2_upper_rig{
    .head_upper2{
        margin-bottom: 3vh;
    }
    
}
.eli1{
    position: absolute;
    top:140px;
    right:0;
    z-index:1;

}
.eli2{
    position: absolute;
    top:240px;
    left:30px;
    z-index:1;

}
.eli3{
    position: absolute;
    top:320px;
    left:0;
    z-index:1;

}
.eli4{
    position: absolute;
    top:470px;
    right:20px;
    z-index:1;

}
.small_orange_ellipse{
    z-index:2;
    position: absolute;
    top: 185px;
    //top:130px;
    left:80px;
    opacity: 0;
    @media screen and (max-width: 1200px) {
      display:none;
    }
}
.big_blue_ellipse{
    z-index:2;
    position:absolute;
    //top:230px;
    top: 276px;
    left:0px;
    opacity: 0;

    @media screen and (max-width: 1200px) {
      display:none;
    }
}
.big_half_blue_ellipse{
    z-index:1;
    position:absolute;
    //top:100px;
    top: 143px;
    right: 0px;
    opacity: 0;

    @media screen and (max-width: 1200px) {
      display:none;
    }
}
.small_blue_ellipse{
    z-index:2;
    position:absolute;
    //top:400px;
    top: 460px;
    right: 40px;
    opacity: 0;

    @media screen and (max-width: 1200px) {
      display:none;
    }
}
.big_orange_ellipse{
    z-index:3;
    position:absolute;
    //top:620px;
    top:675px;
    right:120px;
    opacity: 0;

    @media screen and (max-width: 1200px) {
      display:none;
    }
}
.small_half_blue_ellipse{
    position:absolute;
    z-index:1;
    //top:1030px;
    top:2000px;
    right:120px;
    opacity: 0;

    @media screen and (max-width: 1200px) {
        display:none;
    }
}
.el1{
    position:absolute;
    top:3500px;
    left:0;
    z-index: -1;

    @media screen and (max-width: 1400px) {
        display:none;
    }
}
.el2{
    position:absolute;
    top: 4500px;
    right:103px;
    z-index: -1;

    @media screen and (max-width: 1400px) {
        display:none;
    }
}
.el3{
    position:absolute;
    top: 4653px;
    right: 0px;
    z-index: -1;

    @media screen and (max-width: 1400px) {
        display:none;
    }
}
.el4{
    position:absolute;
    top:5250px;
    right:103px;
    z-index: -1;

    @media screen and (max-width: 1400px) {
        display:none;
    }
}
.el5{
    position:absolute;
    top:5500px;
    left:86px;
    z-index: -1;
    @media screen and (max-width: 1400px) {
        display:none;
    }
}
.el6{
    position:absolute;
    top: 6700px;
    right:48px;
    z-index: -1;

    @media screen and (max-width: 1400px) {
        display:none;
    }
}
.el7{
    position:absolute;
    top:6700px;
    left:32px;
    z-index: -1;

    @media screen and (max-width: 1400px) {
        display:none;
    }
}
.el8{
    position:absolute;
    top:7650px;
    right: 0px;
    z-index: -1;

    @media screen and (max-width: 1400px) {
        display:none;
    }
}
.el9{
    position:absolute;
    top:7960px;
    left:50px;
    z-index: -1;

    @media screen and (max-width: 1400px) {
        display:none;
    }
}
.el10{
    position:absolute;
    top:8050px;
    right:85px;
    z-index: -1;

    @media screen and (max-width: 1400px) {
        display:none;
    }
}
.scene{
    position:absolute;
    top: 0;
    left:0;
    right:0;
    height: 100vh;
    width: 100vw;
}
.med-text {

    // Regular Monitor > 1024px
    @media (min-width: 1025px) {
      #self-medication-block {
        display: flex !important;
        justify-content: space-around !important;
        align-items: center !important;

        #self-medication-svg {
          display: none !important;
        }

        .word {
          display: flex !important;
        }
      }
    }

    // Tablets < 1024px
    @media (max-width: 1025px) {
      #self-medication-block {
        #self-medication-svg {
          display: block !important;
        }

        .word {
          display: none !important;
        }
      }
    }

    #self-medication-block {
      width: 100%;
      height: 15vh;
      bottom: 0;
      left: 0;
      position: fixed;
      z-index: 100;

      box-shadow: 0 0 20px 0 rgba(154, 90, 176, 0.2);
      background: #EFF1F3;


      #self-medication-svg {
        width: 100%;
        height: 100%;

        .self-medication-svg-letter {
          fill: #A5A4A4;
        }
      }

      .word {
        display: flex;
        justify-content: center;

        .letter {
          width: 2vw;
          height: 15vh;
          background-position: center;
          background-repeat: no-repeat;
          background-size: cover;

          &.bigger-letter {
            width: 3vw;
          }

          &.smaller-letter {
            width: 1vw;
          }

          &.znak {
            background-image: url('../assets/img/footer/znak.svg');
          }

          &.s {
            background-image: url('../assets/img/footer/s_letter.svg');
          }

          &.a {
            background-image: url('../assets/img/footer/a_letter.svg');
          }

          &.m {
            background-image: url('../assets/img/footer/m_letter.svg');
          }

          &.o {
            background-image: url('../assets/img/footer/o_letter.svg');
          }

          &.l {
            background-image: url('../assets/img/footer/l_letter.svg');
          }

          &.i {
            background-image: url('../assets/img/footer/i_letter.svg');
          }

          &.k {
            background-image: url('../assets/img/footer/k_letter.svg');
          }

          &.u {
            background-image: url('../assets/img/footer/u_letter.svg');
          }

          &.v {
            background-image: url('../assets/img/footer/v_letter.svg');
          }

          &.n {
            background-image: url('../assets/img/footer/n_letter.svg');
          }

          &.e {
            background-image: url('../assets/img/footer/e_letter.svg');
          }

          &.b {
            background-image: url('../assets/img/footer/b_letter.svg');
          }

          &.t {
            background-image: url('../assets/img/footer/t_letter.svg');
          }

          &.g {
            background-image: url('../assets/img/footer/g_letter.svg');
          }

          &.d {
            background-image: url('../assets/img/footer/d_letter.svg');
          }

          &.z {
            background-image: url('../assets/img/footer/z_letter.svg');
          }

          &.r {
            background-image: url('../assets/img/footer/r_letter.svg');
          }

          &.ia {
            background-image: url('../assets/img/footer/ia_letter.svg');
          }

          &.ge {
            background-image: url('../assets/img/footer/ge_letter.svg');
          }

          &.ii {
            background-image: url('../assets/img/footer/ii_letter.svg');
          }

          &.sh {
            background-image: url('../assets/img/footer/sh_letter.svg');
          }
        }
      }
    }
  }
#saf1{
    font-family: $fontB;
}
#saf2{
    font-family: $fontB;
}
</style>